/**
 * Ruckstuhl Configuration Core V8 – Theme-only
 *
 * Gemeinsamer Abschluss für alle individuellen Teppichkonfiguratoren:
 * - temporäre Konfigurationsreferenz KONF-…
 * - einheitliche PDF-/Druckansicht
 * - teilbarer Konfigurationslink ohne persönliche Kundendaten
 * - Händlerauswahl
 * - Schweiz: Bestellanfrage an Ruckstuhl zur manuellen Erfassung als Shopify-Bestellentwurf
 * - Schweiz/Ausland: Beratung durch Fachhandel oder Ruckstuhl
 * - keine App, keine dynamische Artikelerstellung, kein Teppich-Warenkorb
 */
(function () {
  'use strict';

  if (window.RKConfiguration && window.RKConfiguration.version) return;

  const DEFAULTS = {
    country: 'CH',
    currency: 'CHF',
    taxIncluded: true,
    ruckstuhlEmail: 'info@ruckstuhl.com',
    pdfLogoUrl: '',
    customerNumber: 'GAST',
    customerName: '', customerEmail: '', customerPhone: '', customerCompany: '', customerAddress: '', customerPostal: '', customerCity: '',
    customerEmail: '',
    contactFormId: 'rk-configuration-contact-form',
    googleMapsApiKey: '',
    dealers: [],
    partnerMode: false,
    partnerDealer: null,
    ruckstuhlLocation: {
      id: 'ruckstuhl-langenthal',
      name: 'Ruckstuhl AG – Manufaktur Langenthal',
      country: 'CH',
      city: 'Langenthal',
      address: '',
      email: 'info@ruckstuhl.com',
      phone: '',
      accepts_online_orders: false,
      accepts_consultation: true,
      is_ruckstuhl: true
    },
    labels: {
      orderRequest: 'Bestellung absenden', dealerAdvice: 'Beratung durch Fachhandel', ruckstuhlAdvice: 'Beratung bei Ruckstuhl',
      dialogAria: 'Bestellung und Beratung', continueTitle: 'Wie möchten Sie fortfahren?', close: 'Schliessen',
      copyLink: 'Konfigurationslink kopieren', shareLink: 'Link teilen', pdf: 'PDF herunterladen', continue: 'Weiter',
      reference: 'Konfigurationsreferenz', product: 'Produkt', price: 'Preis',
      swissNote: 'Der angezeigte Schweizer Preis versteht sich inklusive MWST. Nach Eingang Ihrer Bestellanfrage prüft Ruckstuhl die Konfiguration und sendet Ihnen einen sicheren Zahlungslink.',
      internationalNote: 'Der direkte Bestellweg ist vorerst nur für die Schweiz verfügbar. Ihre Konfiguration kann an einen Fachhandelspartner oder an Ruckstuhl weitergegeben werden.',
      orderDescription: 'Händler in der Region wählen, Bestellung an Ruckstuhl übermitteln und anschliessend einen sicheren Zahlungslink erhalten.',
      dealerDescription: 'Fachhandel auswählen und den teilbaren Konfigurationslink weitergeben.',
      ruckstuhlDescription: 'Händler oder Standort wählen und die Konfiguration an Ruckstuhl übermitteln.',
      noDealer: 'Kein passender Fachhandelspartner gefunden. Versuchen Sie eine andere PLZ oder einen anderen Ort.',
      backToDealerResults: 'Zurück zu Suchresultaten',
      contactHeading: 'Ihre Angaben', name: 'Name', email: 'E-Mail', phone: 'Telefon', company: 'Firma / Büro',
      deliveryAddress: 'Lieferadresse', postal: 'PLZ', city: 'Ort', projectNote: 'Projekt / Bemerkung',
      dealerOrderHeading: 'Fachhandel für Ihre Bestellung', dealerAdviceHeading: 'Fachhandel für die Beratung', ruckstuhlHeading: 'Händler oder Ruckstuhl auswählen',
      dealerSearch: 'PLZ, Ort oder Händlername', dealerSearchPlaceholder: 'z. B. 8001 Zürich',
      shareLegal: 'Nach der Auswahl können Sie den Konfigurationslink über das Teilen-Menü senden oder kopieren. Persönliche Kundendaten sind nicht im Link enthalten.',
      orderLegal: 'Mit „Bestellung absenden“ übermitteln Sie Ihre Kaufabsicht zur Prüfung. Ruckstuhl prüft die Konfiguration und sendet Ihnen anschliessend einen sicheren Zahlungslink. Die Produktion beginnt erst nach Zahlung und Auftragsbestätigung.',
      ruckstuhlLegal: 'Die Konfiguration und Ihre Kontaktdaten werden an Ruckstuhl gesendet. Der ausgewählte Händler oder Standort wird zur regionalen Zuordnung mitübermittelt.',
      shareDealer: 'Link an Fachhandel teilen', sendRuckstuhl: 'Anfrage an Ruckstuhl senden', copied: 'Konfigurationslink wurde kopiert.',
      copyPrompt: 'Konfigurationslink kopieren:', shared: 'Konfigurationslink wurde geteilt.',
      routeOrder: 'Bestellanfrage Schweiz', routeDealer: 'Beratung durch Fachhandel', routeRuckstuhl: 'Beratung bei Ruckstuhl',
      country: 'Land', configuration: 'Konfiguration', selectedDealer: 'Ausgewählter Fachhandel / Standort', id: 'ID', address: 'Adresse',
      customerData: 'Kundendaten', postalCity: 'PLZ / Ort', desiredFlow: 'Gewünschter Ablauf: Konfiguration prüfen und sicheren Zahlungslink senden.',
      noValue: '—', subjectOrder: 'Bestellanfrage', subjectAdvice: 'Beratungsanfrage',
      missingForm: 'Das Shopify-Kontaktformular wurde nicht gefunden. Bitte den Ruckstuhl-Bootstrap global einbauen.',
      sending: 'Anfrage wird an Ruckstuhl übermittelt …', sent: 'Ihre Anfrage wurde erfolgreich an Ruckstuhl übermittelt.', linkCopied: 'Link kopiert.', dealerEmail: 'Händler-E-Mail:', genericError: 'Der Vorgang konnte nicht abgeschlossen werden.',
      carpetConfiguration: 'Teppichkonfiguration', carpetLabel: 'Teppich', openConfiguration: 'Konfiguration öffnen:', openConfigurationShort: 'Konfiguration online öffnen',
      additionalRug: 'Zusatzteppich', pdfNote: 'Individuelle Konfiguration. Preis und technische Machbarkeit werden vor der definitiven Auftragsbestätigung geprüft. Die definitive Angebots- und Auftragsnummer wird im ERP vergeben.',
      sharedOpened: 'Diese Konfiguration wurde über einen Link geöffnet.', preview: 'Vorschau', taxIncluded: 'inkl. MWST', taxExcluded: 'exkl. MWST'
    }
  };

  const settings = merge(DEFAULTS, window.RK_CONFIGURATION_SETTINGS || {});
  const state = {
    detail: null,
    normalized: null,
    route: '',
    selectedDealer: null,
    busy: false,
    shareUrl: '',
    openedFromLink: false,
    dealerSearchPoint: null,
    dealerSearchCountry: '',
    dealerSearchLocality: '',
    dealerSearchQuery: '',
    dealerSearchToken: 0
  };

  function merge(a, b) {
    const out = Object.assign({}, a, b || {});
    out.labels = Object.assign({}, a.labels || {}, (b && b.labels) || {});
    out.ruckstuhlLocation = Object.assign({}, a.ruckstuhlLocation || {}, (b && b.ruckstuhlLocation) || {});
    out.dealers = Array.isArray(b && b.dealers) ? b.dealers : (a.dealers || []);
    return out;
  }

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function label(key, fallback) {
    return clean(settings.labels && settings.labels[key]) || clean(fallback || key);
  }

  function slug(value) {
    return clean(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function html(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function number(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    let text = String(value == null ? '' : value)
      .replace(/(?:CHF|EUR|GBP|USD|ALL|BAM|BYN|CZK|DKK|HUF|ISK|MDL|MKD|NOK|PLN|RON|RSD|SEK|TRY|UAH)/gi, '')
      .replace(/inkl\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:MWST|VAT|TVA|IVA|tax)/gi, '')
      .replace(/exkl\.?\s*(?:MWST|VAT|TVA|IVA|tax)/gi, '')
      .replace(/[’'\s]/g, '')
      .replace(/[^0-9,.-]/g, '');
    if (!text) return 0;

    const comma = text.lastIndexOf(',');
    const dot = text.lastIndexOf('.');
    if (comma >= 0 && dot >= 0) {
      const decimal = comma > dot ? ',' : '.';
      const grouping = decimal === ',' ? /\./g : /,/g;
      text = text.replace(grouping, '').replace(decimal, '.');
    } else if (comma >= 0 || dot >= 0) {
      const separator = comma >= 0 ? ',' : '.';
      const parts = text.split(separator);
      const last = parts[parts.length - 1];
      if (parts.length > 2) {
        text = last.length <= 2 ? parts.slice(0, -1).join('') + '.' + last : parts.join('');
      } else if (last.length <= 2) {
        text = parts[0] + '.' + last;
      } else {
        text = parts.join('');
      }
    }
    const result = Number.parseFloat(text);
    return Number.isFinite(result) ? result : 0;
  }

  function currentLocale() {
    return clean(document.documentElement && document.documentElement.lang) || 'de-CH';
  }

  /* RK V25: Zahlformatierung fuer Zusatzteppiche.
     Der Reststueck-PDF-Pfad verwendete localizedNumber(), ohne dass die
     Funktion im Configuration Core definiert war. Das fuehrte ausschliesslich
     bei vorhandenen rest_rugs zu einem ReferenceError und brach den PDF-Klick ab. */
  function localizedNumber(value, minimumFractionDigits, maximumFractionDigits) {
    const amount = number(value);
    const min = Number.isFinite(Number(minimumFractionDigits)) ? Number(minimumFractionDigits) : 0;
    const max = Number.isFinite(Number(maximumFractionDigits)) ? Number(maximumFractionDigits) : Math.max(2, min);
    try {
      return new Intl.NumberFormat(currentLocale(), {
        minimumFractionDigits: min,
        maximumFractionDigits: Math.max(min, max)
      }).format(amount);
    } catch (error) {
      return amount.toFixed(Math.max(min, max)).replace('.', ',');
    }
  }

  function money(value, currency) {
    const amount = number(value);
    const code = clean(currency || (window.RuckstuhlMarket && window.RuckstuhlMarket.currency ? window.RuckstuhlMarket.currency() : '') || settings.currency || 'CHF') || 'CHF';
    try {
      return new Intl.NumberFormat(currentLocale(), {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return code + ' ' + amount.toFixed(2);
    }
  }

  function localizePriceText(value) {
    const source = String(value == null ? '' : value);
    if (!window.RuckstuhlMarket) return source;
    const grossSource = /inkl\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/i.test(source);
    if (window.RuckstuhlMarket.localizeText) return window.RuckstuhlMarket.localizeText(source, grossSource ? 'gross' : 'net');
    if (!/CHF\s*[0-9]/i.test(source)) return source;
    return source;
  }

  function countryCode() {
    const selectedCountry = clean(window.RuckstuhlMarket && window.RuckstuhlMarket.countryCode ? window.RuckstuhlMarket.countryCode() : '').toUpperCase();
    const shopifyCountry = clean(window.Shopify && window.Shopify.country).toUpperCase();
    return selectedCountry || shopifyCountry || clean(settings.country).toUpperCase() || 'CH';
  }

  function isSwitzerland() {
    if (window.RuckstuhlMarket && window.RuckstuhlMarket.isSwitzerland) return window.RuckstuhlMarket.isSwitzerland();
    return countryCode() === 'CH';
  }

  function nowParts() {
    const date = new Date();
    const pad = function (value) { return String(value).padStart(2, '0'); };
    return {
      date: String(date.getFullYear()) + pad(date.getMonth() + 1) + pad(date.getDate()),
      time: pad(date.getHours()) + pad(date.getMinutes()) + pad(date.getSeconds()),
      iso: date.toISOString()
    };
  }

  function simpleHash(value) {
    const text = String(value || '');
    let hash = 2166136261;
    for (let index = 0; index < text.length; index += 1) {
      hash ^= text.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function configurationReference(identity, supplied) {
    const given = clean(supplied);
    if (given) return given;
    const key = 'rk_configuration_reference_' + simpleHash(JSON.stringify(identity || {}));
    try {
      const existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      const parts = nowParts();
      const customer = clean(settings.customerNumber || 'GAST').replace(/[^A-Za-z0-9_-]/g, '') || 'GAST';
      const created = ['KONF', customer, parts.date, parts.time].join('-');
      window.sessionStorage.setItem(key, created);
      return created;
    } catch (error) {
      const parts = nowParts();
      return ['KONF', 'GAST', parts.date, parts.time].join('-');
    }
  }

  function dedupeDetailRows(rows) {
    const out = [];
    const seen = new Map();
    let variantPresent = false;
    (Array.isArray(rows) ? rows : []).forEach(function (row) {
      if (!row) return;
      let rowLabel = clean(row.label || row.key || '');
      let rowValue = clean(row.value || '');
      rowValue = rowValue.replace(/\s*\(\s*\)\s*$/,'').trim();
      if (/^true$/i.test(rowValue)) rowValue = 'Ja';
      if (/^false$/i.test(rowValue)) rowValue = 'Nein';
      if (!rowLabel || !rowValue) return;
      let key = slug(rowLabel);
      if (key === 'variante') variantPresent = true;
      if (seen.has(key)) {
        const existing = out[seen.get(key)];
        if (key === 'produkt' && existing && clean(existing.value) !== rowValue && !variantPresent) {
          rowLabel = 'Variante';
          key = 'variante';
          variantPresent = true;
        } else {
          return;
        }
      }
      if (seen.has(key)) return;
      seen.set(key, out.length);
      out.push({ label: rowLabel, value: rowValue, private: !!row.private });
    });
    return out;
  }

  function translatedDetailLabel(value) {
    const original = clean(value);
    const key = slug(original);
    const map = {
      'ausfuhrung': ['step_execution', 'Execution'], 'execution': ['step_execution', 'Execution'],
      'form': ['shape', 'Shape'], 'shape': ['shape', 'Shape'], 'format': ['shape', 'Format'],
      'grosse': ['dimension', 'Dimension'], 'groesse': ['dimension', 'Dimension'], 'dimension': ['dimension', 'Dimension'],
      'colorit': ['carpet_color', 'Colourway'], 'farbe': ['carpet_color', 'Colourway'], 'teppichfarbe': ['carpet_color', 'Colourway'],
      'einfassung': ['edging', 'Edging'], 'colorit-einfassung': ['edging_color', 'Edging colourway'], 'einfassung-colorit': ['edging_color', 'Edging colourway'],
      'extras': ['extras', 'Extras'], 'zusatzausstattung': ['extras', 'Extras'], 'zusatzausstattungen': ['extras', 'Extras'],
      'material': ['step_material', 'Material'], 'laufrichtung': ['direction', 'Pile direction'], 'reststucke': ['remnants', 'Remnants'],
      'schweissnaht': ['weld_singular', 'Welded seam'], 'schweissnahte': ['weld_plural', 'Welded seams'],
      'produkt': ['product', label('product', 'Product')], 'product': ['product', label('product', 'Product')],
      'variante': ['variant', 'Variant'], 'variant': ['variant', 'Variant'],
      'preis': ['price', label('price', 'Price')], 'price': ['price', label('price', 'Price')]
    };
    const item = map[key];
    if (!item) return original;
    if (window.RKV8T) return window.RKV8T(item[0], item[1]);
    if (item[0] === 'product') return label('product', item[1]);
    if (item[0] === 'price') return label('price', item[1]);
    return item[1];
  }

  function translateDetailRows(rows) {
    return (Array.isArray(rows) ? rows : []).map(function (row) {
      if (!row) return row;
      return Object.assign({}, row, { label: translatedDetailLabel(row.label || row.key || '') });
    });
  }

  function normalizeDetails(detail) {
    const rows = [];
    const push = function (rowLabel, value, privateRow) {
      const cleanLabel = clean(rowLabel);
      let cleanValue = Array.isArray(value) ? value.filter(Boolean).join(', ') : clean(value);
      cleanValue = localizePriceText(cleanValue);
      if (!cleanLabel || !cleanValue || cleanValue === label('noValue', '—') || cleanValue === '-') return;
      const labelKey = slug(cleanLabel);
      if (labelKey === 'extras' || labelKey === 'zusatzausstattung' || labelKey === 'zusatzausstattungen') {
        cleanValue = cleanValue
          .replace(/([^\s·,;])(?=(?:CHF|EUR|USD)\b)/gi, '$1 · ')
          .replace(/([A-Za-zÄÖÜäöüß])(?=\d)/g, '$1 ');
      }
      if (['preis', 'gesamtpreis', 'total'].includes(labelKey)) return;
      if (['produkt', 'product', 'teppich', 'carpet'].includes(labelKey)) return;
      rows.push({ label: translatedDetailLabel(cleanLabel), value: cleanValue, private: !!privateRow });
    };

    if (Array.isArray(detail && detail.details)) {
      detail.details.forEach(function (row) {
        if (!row) return;
        if (Array.isArray(row)) push(row[0], row[1], row[2]);
        else push(row.label, row.value, row.private);
      });
    }

    const cfg = detail && detail.configuration ? detail.configuration : {};
    const restRugs = [
      detail && detail.rest_rugs,
      detail && detail.restRugs,
      cfg && cfg.rest_rugs,
      cfg && cfg.restRugs,
      detail && detail.raw && detail.raw.configuration && detail.raw.configuration.rest_rugs
    ].find(Array.isArray) || [];
    restRugs.forEach(function (rug, index) {
      if (!rug) return;
      const width = number(rug.width_m != null ? rug.width_m : rug.width);
      const length = number(rug.length_m != null ? rug.length_m : rug.length);
      const shape = clean(rug.shape || '');
      if (!(width > 0 && length > 0)) return;
      const size = localizedNumber(width, 2, 2) + ' × ' + localizedNumber(length, 2, 2) + ' m';
      const finish = [clean(rug.edging||''), clean(rug.edging_color||rug.edgingColor||'')].filter(Boolean).join(' · ');
      const rugPrice = clean(rug.price||rug.price_text||'');
      const rugValue = [(shape ? shape : ''), size, finish, rugPrice].filter(Boolean).join(' · ');
      push((label('additionalRug', 'Zusatzteppich') + ' ' + (index + 1)), rugValue);
    });
    if (!rows.length) {
      push('Ausführung', cfg.mode || cfg.execution || cfg.finish || detail.execution);
      push('Form', cfg.shape || detail.shape);
      push('Format', cfg.format || detail.format);
      push('Grösse', cfg.size || cfg.dimension || detail.size || detail.dimension);
      if (!cfg.size && !cfg.dimension) {
        const width = number(cfg.width_m || detail.width_m);
        const length = number(cfg.length_m || detail.length_m);
        const diameter = number(cfg.diameter_m || detail.diameter_m);
        if (diameter) push('Grösse', 'Ø ' + diameter.toFixed(2).replace('.', ',') + ' m');
        else if (width && length) push('Grösse', width.toFixed(2).replace('.', ',') + ' × ' + length.toFixed(2).replace('.', ',') + ' m');
      }
      push('Colorit', cfg.color || cfg.carpet_color || detail.color);
      push('Einfassung', cfg.edging || detail.edging);
      push('Colorit Einfassung', cfg.edging_color || cfg.edgingColor || detail.edging_color);
      push('Extras', cfg.extras || detail.extras);
    }

    return dedupeDetailRows(rows);
  }

  function normalize(detail) {
    detail = detail || {};
    if (detail.schema_version === 8 && detail.reference && Array.isArray(detail.details)) {
      const selectedMarket = window.RuckstuhlMarket && window.RuckstuhlMarket.current ? window.RuckstuhlMarket.current() : null;
      const productionObject = detail.production && typeof detail.production === 'object' ? detail.production : {};
      const productionNet = number(productionObject.net_price || productionObject.total_net || detail.net_price || detail.total_net);
      let priceNumber = number(detail.price_gross || detail.price_number || detail.price_text);
      let priceText = clean(detail.price_text || money(priceNumber, detail.currency));
      let currency = clean(detail.currency || settings.currency || 'CHF');
      let country = clean(detail.country || countryCode()).toUpperCase();
      let taxIncluded = detail.tax_included !== false;
      if (selectedMarket) {
        country = clean(selectedMarket.country_code || countryCode()).toUpperCase();
        currency = clean(selectedMarket.currency_code || settings.currency || 'CHF');
        taxIncluded = selectedMarket.tax_calculation_mode === 'fixed' && number(selectedMarket.vat_rate) > 0;
        if (productionNet > 0 && window.RuckstuhlMarket.convertNet && window.RuckstuhlMarket.formatNet) {
          priceNumber = window.RuckstuhlMarket.convertNet(productionNet);
          priceText = window.RuckstuhlMarket.formatNet(productionNet);
        }
      }
      const details = dedupeDetailRows(translateDetailRows(detail.details)).map(function (row) {
        return Object.assign({}, row, { value: localizePriceText(row.value) });
      });
      return Object.assign({}, detail, {
        country: country,
        currency: currency,
        tax_included: taxIncluded,
        price_gross: priceNumber,
        price_text: priceText,
        details: details
      });
    }

    const productObject = detail.product && typeof detail.product === 'object' ? detail.product : {};
    const priceObject = detail.price && typeof detail.price === 'object' ? detail.price : {};
    const productTitle = clean(
      detail.product_title ||
      (typeof detail.product === 'string' ? detail.product : '') ||
      detail.title ||
      productObject.title ||
      (detail.configuration && detail.configuration.product) ||
      'Ruckstuhl Teppich'
    );
    const productType = clean(detail.product_type || detail.type || detail.configuratorType || 'configuration');
    let priceText = clean(
      typeof detail.price === 'string' ? detail.price : '' ||
      detail.salePrice ||
      detail.total_text ||
      priceObject.total_text ||
      (detail.configuration && detail.configuration.price)
    );
    let priceNumber = number(
      detail.price_number ||
      detail.total_number ||
      detail.total ||
      detail.sale_price_number ||
      detail.salePriceNumber ||
      priceText ||
      priceObject.total
    );
    const details = normalizeDetails(detail);
    const sourceProductId = clean(detail.product_id || detail.source_product_id || detail.sourceProductId || productObject.id || '');
    const sourceProductHandle = clean(detail.product_handle || detail.source_product_handle || detail.sourceProductHandle || productObject.handle || '');
    const sourceProductUrl = clean(detail.product_url || detail.source_product_url || detail.sourceProductUrl || detail.source || window.location.href.split('#')[0]);
    const previewImage = clean(detail.preview_image || detail.previewImage || detail.image || '');
    const previewImagesRaw = Array.isArray(detail.preview_images) ? detail.preview_images : [
      detail.carpet_image,
      detail.edging_image,
      detail.sketch_image,
      previewImage
    ];
    const previewImages = previewImagesRaw.map(clean).filter(function (value, index, list) {
      return value && list.indexOf(value) === index;
    });
    const carpetImage = clean(detail.carpet_image || previewImage || '');
    const edgingImage = clean(detail.edging_image || '');
    const sketchImage = clean(detail.sketch_image || '');
    const sketchSvg = String(detail.sketch_svg || detail.preview_svg || '').trim();
    let country = clean(detail.country || countryCode()).toUpperCase();
    let currency = clean(detail.currency || priceObject.currency || settings.currency || 'CHF');
    let taxIncluded = detail.tax_included != null ? detail.tax_included !== false : (country === 'CH' ? true : settings.taxIncluded !== false);
    const selectedMarket = window.RuckstuhlMarket && window.RuckstuhlMarket.current ? window.RuckstuhlMarket.current() : null;
    const productionObject = detail.production && typeof detail.production === 'object' ? detail.production : {};
    const productionNet = number(
      productionObject.net_price ||
      productionObject.total_net ||
      priceObject.net_price ||
      detail.net_price ||
      detail.total_net
    );
    if (selectedMarket) {
      country = clean(selectedMarket.country_code || countryCode()).toUpperCase();
      currency = clean(selectedMarket.currency_code || settings.currency || 'CHF');
      taxIncluded = selectedMarket.tax_calculation_mode === 'fixed' && number(selectedMarket.vat_rate) > 0;
      if (productionNet > 0 && window.RuckstuhlMarket.convertNet && window.RuckstuhlMarket.formatNet) {
        priceNumber = window.RuckstuhlMarket.convertNet(productionNet);
        priceText = window.RuckstuhlMarket.formatNet(productionNet);
      } else if (priceNumber > 0 && window.RuckstuhlMarket.convertNet && window.RuckstuhlMarket.formatNet) {
        const sourceLooksGross = /inkl\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tax)/i.test(priceText) || detail.tax_included === true;
        const sourceCurrency = clean(detail.currency || priceObject.currency || 'CHF').toUpperCase();
        const selectedCode = clean(selectedMarket.currency_code || currency).toUpperCase();
        const selectedCurrencyAlreadyShown = selectedCode && new RegExp('\\b' + selectedCode.replace(/[^A-Z]/g, '') + '\\b', 'i').test(priceText) && sourceCurrency === selectedCode;
        if (!selectedCurrencyAlreadyShown) {
          const originalPrice = number(detail.price_number || detail.total_number || detail.total || detail.sale_price_number || detail.salePriceNumber || priceText);
          if (sourceLooksGross && window.RuckstuhlMarket.convertBaseGross && window.RuckstuhlMarket.formatGrossChf) {
            priceNumber = window.RuckstuhlMarket.convertBaseGross(originalPrice);
            priceText = window.RuckstuhlMarket.formatGrossChf(originalPrice);
          } else {
            priceNumber = window.RuckstuhlMarket.convertNet(originalPrice);
            priceText = window.RuckstuhlMarket.formatNet(originalPrice);
          }
        }
      }
    }

    const identity = {
      product_type: productType,
      source_product_id: sourceProductId,
      source_product_handle: sourceProductHandle,
      product_title: productTitle,
      price: priceText || priceNumber,
      details: details
    };
    const reference = configurationReference(identity, detail.reference || detail.configuration_reference || detail.client_configuration_id);

    return {
      schema_version: 8,
      reference: reference,
      created_at: clean(detail.created_at || nowParts().iso),
      configurator_type: productType,
      source_product_id: sourceProductId,
      source_product_handle: sourceProductHandle,
      source_product_url: sourceProductUrl,
      product_title: productTitle,
      configuration_title: clean(detail.configuration_title || (detail.configuration && detail.configuration.mode) || productTitle),
      price_gross: priceNumber,
      price_text: priceText || money(priceNumber, currency),
      currency: currency,
      tax_included: taxIncluded,
      country: country,
      dealer_scope_all: detail.dealer_scope_all === true,
      dealer_scope: Array.isArray(detail.dealer_scope) ? detail.dealer_scope.slice() : [],
      details: details,
      preview_image: previewImage,
      preview_images: previewImages,
      carpet_image: carpetImage,
      edging_image: edgingImage,
      sketch_image: sketchImage,
      sketch_svg: sketchSvg,
      production: detail.production || {},
      selections: detail.selections || detail.configuration || {},
      raw: detail
    };
  }

  function priceWithTax(configuration) {
    const text = clean(configuration.price_text || money(configuration.price_gross, configuration.currency));
    if (/mwst|mehrwertsteuer|vat|tva|iva|tax/i.test(text)) return text;
    if (window.RuckstuhlMarket && window.RuckstuhlMarket.priceSuffix) return text + '\u00A0' + window.RuckstuhlMarket.priceSuffix();
    return text + '\u00A0' + (configuration.tax_included ? label('taxIncluded', 'inkl. MWST') : label('taxExcluded', 'exkl. MWST'));
  }

  function sharePayload(configuration) {
    const cfg = normalize(configuration);
    return {
      schema_version: 8,
      reference: cfg.reference,
      created_at: cfg.created_at,
      configurator_type: cfg.configurator_type,
      source_product_id: cfg.source_product_id,
      source_product_handle: cfg.source_product_handle,
      source_product_url: cfg.source_product_url,
      product_title: cfg.product_title,
      configuration_title: cfg.configuration_title,
      price_gross: cfg.price_gross,
      price_text: cfg.price_text,
      currency: cfg.currency,
      tax_included: cfg.tax_included,
      country: cfg.country,
      dealer_scope_all: cfg.dealer_scope_all === true,
      dealer_scope: Array.isArray(cfg.dealer_scope) ? cfg.dealer_scope.slice() : [],
      net_price: number(cfg.production && (cfg.production.net_price || cfg.production.total_net)),
      production: cfg.production && typeof cfg.production === 'object' ? {
        net_price: number(cfg.production.net_price || cfg.production.total_net),
        finished_area_m2: number(cfg.production.finished_area_m2),
        production_area_m2: number(cfg.production.production_area_m2)
      } : {},
      details: cfg.details.filter(function (row) { return !row.private; }),
      preview_image: /^data:/i.test(clean(cfg.preview_image)) ? '' : cfg.preview_image
    };
  }

  function utf8ToBase64Url(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }

  function base64UrlToUtf8(encoded) {
    const value = String(encoded || '').replace(/-/g, '+').replace(/_/g, '/');
    const padded = value + '='.repeat((4 - value.length % 4) % 4);
    const binary = window.atob(padded);
    const bytes = Uint8Array.from(binary, function (character) { return character.charCodeAt(0); });
    return new TextDecoder().decode(bytes);
  }

  function getShareUrl(configuration) {
    const cfg = normalize(configuration);
    const payload = utf8ToBase64Url(JSON.stringify(sharePayload(cfg)));
    const base = clean(cfg.source_product_url || window.location.href).split('#')[0];
    return base + '#rk-config=' + payload;
  }

  function decodeSharedLink() {
    const match = String(window.location.hash || '').match(/^#rk-config=([^&]+)/);
    if (!match) return null;
    try {
      const parsed = JSON.parse(base64UrlToUtf8(match[1]));
      return normalize(parsed);
    } catch (error) {
      console.warn('Ruckstuhl Konfigurationslink konnte nicht gelesen werden.', error);
      return null;
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function ensureStyle() {
    if (document.getElementById('rk-configuration-core-style')) return;
    const style = document.createElement('style');
    style.id = 'rk-configuration-core-style';
    style.textContent = `
      .rk-core[hidden]{display:none!important}.rk-v8-shape-native{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;margin:-1px!important;padding:0!important;border:0!important}.rk-v8-shape-cards{display:grid;grid-template-columns:repeat(3,minmax(120px,1fr));gap:12px;margin:10px 0 22px}.rk-v8-shape-card{display:grid;grid-template-rows:72px auto;gap:10px;align-items:center;justify-items:center;border:1px solid rgba(0,0,0,.18);background:#fff;color:#242f3c;padding:14px 12px;cursor:pointer;font:inherit;text-align:center}.rk-v8-shape-card.is-selected{border-color:#111;box-shadow:inset 0 0 0 1px #111}.rk-v8-shape-card__symbol{display:block;width:62px;height:42px;border:1.5px solid currentColor;background:#f7f7f5}.rk-v8-shape-card__symbol--square{width:44px;height:44px}.rk-v8-shape-card__symbol--runner{width:72px;height:30px}.rk-v8-shape-card__symbol--round{width:46px;height:46px;border-radius:50%}.rk-v8-shape-card__symbol--oval{width:70px;height:40px;border-radius:50%}.rk-v8-shape-card__label{font-size:12px;line-height:1.3;letter-spacing:.08em;text-transform:uppercase}.rk-core{position:fixed;inset:0;z-index:2147483000;font-family:"Ruckstuhl Avenir",Avenir,"Avenir Next",Arial,sans-serif;color:#242f3c}.rk-core__overlay{position:absolute;inset:0;background:rgba(255,255,255,.72);backdrop-filter:blur(3px)}.rk-core__dialog{position:absolute;top:20px;right:20px;bottom:20px;width:min(760px,calc(100vw - 40px));background:#fff;box-shadow:0 30px 90px rgba(0,0,0,.17);display:grid;grid-template-rows:auto minmax(0,1fr) auto}.rk-core__head{display:flex;justify-content:space-between;gap:20px;padding:30px 32px 22px;border-bottom:1px solid rgba(0,0,0,.12)}.rk-core__eyebrow,.rk-core__label{margin:0;text-transform:uppercase;letter-spacing:.18em;font-size:10px;color:rgba(36,47,60,.5)}.rk-core__head h2{margin:7px 0 0;font-size:24px;line-height:1.2;font-weight:400}.rk-core__close{border:0;background:transparent;font-size:40px;line-height:1;cursor:pointer;color:inherit}.rk-core__body{padding:28px 32px 42px;overflow:auto}.rk-core__reference{display:flex;justify-content:space-between;gap:18px;align-items:center;padding:13px 15px;background:#f6f5f2;margin-bottom:18px;font-size:13px}.rk-core__reference strong{font-weight:400;overflow-wrap:anywhere}.rk-core__summary{border-top:1px solid rgba(0,0,0,.13);margin-bottom:22px}.rk-core__summary-row{display:grid;grid-template-columns:minmax(140px,.8fr) minmax(0,1.2fr);gap:20px;padding:10px 0;border-bottom:1px solid rgba(0,0,0,.08);font-size:14px}.rk-core__summary-row span{color:rgba(36,47,60,.58)}.rk-core__summary-row strong{font-weight:400}.rk-core__price{font-size:22px!important}.rk-core__sharebar{display:flex;gap:9px;flex-wrap:wrap;margin:0 0 24px}.rk-core__routes{display:grid;gap:12px}.rk-core__route{width:100%;text-align:left;border:1px solid rgba(0,0,0,.18);background:#fff;padding:17px 18px;cursor:pointer;color:inherit}.rk-core__route strong{display:block;font-weight:400;font-size:16px}.rk-core__route small{display:block;margin-top:5px;color:rgba(36,47,60,.62);font-size:13px;line-height:1.45}.rk-core__route.is-selected{border-color:#111;box-shadow:inset 0 0 0 1px #111}.rk-core__notice{padding:14px 16px;background:#f6f5f2;margin:0 0 18px;font-size:13px;line-height:1.5}.rk-core__panel{margin-top:26px}.rk-core__panel h3{font-size:16px;font-weight:400;margin:0 0 14px}.rk-core__field{margin:0 0 15px}.rk-core__field label{display:block;margin-bottom:7px;text-transform:uppercase;letter-spacing:.14em;font-size:10px;color:rgba(36,47,60,.53)}.rk-core__field input,.rk-core__field textarea{display:block;width:100%;border:1px solid rgba(0,0,0,.18);background:#fff;padding:12px 13px;font:inherit;color:inherit}.rk-core__field input[aria-invalid="true"],.rk-core__field textarea[aria-invalid="true"]{border-color:#9b1c1c;box-shadow:inset 0 0 0 1px #9b1c1c}.rk-core__grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.rk-core__dealer-results{display:grid;gap:9px;margin-top:12px;max-height:min(46vh,460px);overflow:auto;padding-right:4px;overscroll-behavior:contain}.rk-core__dealer{border:1px solid rgba(0,0,0,.14);background:#fff;text-align:left;padding:13px 14px;cursor:pointer;color:inherit}.rk-core__dealer strong{display:block;font-weight:400}.rk-core__dealer small{display:block;margin-top:3px;color:rgba(36,47,60,.6)}.rk-core__dealer em{display:block;margin-top:4px;font-size:12px;font-style:normal;color:rgba(36,47,60,.48)}.rk-core__dealer.is-selected{border-color:#111;box-shadow:inset 0 0 0 1px #111}.rk-core__selected-dealer{position:sticky;bottom:0;z-index:2;margin-top:12px;padding:13px 14px;background:#fff;border:1px solid #111;font-size:13px;line-height:1.5;box-shadow:0 -8px 18px rgba(255,255,255,.94)}.rk-core__selected-back{display:block;margin-top:10px;border:0;border-bottom:1px solid currentColor;background:transparent;padding:2px 0;color:inherit;font:inherit;font-size:12px;cursor:pointer}.rk-core__legal{font-size:12px;line-height:1.5;color:rgba(36,47,60,.62);margin:18px 0 0}.rk-core__footer{border-top:1px solid rgba(0,0,0,.12);padding:18px 32px;display:flex;gap:10px;justify-content:flex-end;align-items:center}.rk-core__button{border:1px solid #111;background:#111;color:#fff;padding:13px 17px;text-transform:uppercase;letter-spacing:.14em;font-size:10px;cursor:pointer}.rk-core__button--quiet{background:#fff;color:#111;border-color:rgba(0,0,0,.2)}.rk-core__button:disabled{opacity:.45;cursor:not-allowed}.rk-core__status{margin-right:auto;font-size:13px;color:rgba(36,47,60,.65)}body.rk-core-open{overflow:hidden}@media(max-width:680px){.rk-v8-shape-cards{grid-template-columns:repeat(2,minmax(110px,1fr))}.rk-core__dialog{inset:0;width:100vw}.rk-core__head,.rk-core__body,.rk-core__footer{padding-left:20px;padding-right:20px}.rk-core__grid,.rk-core__summary-row{grid-template-columns:1fr}.rk-core__summary-row{gap:3px}.rk-core__footer{display:grid;grid-template-columns:1fr}.rk-core__status{margin:0}.rk-core__button{width:100%}}
    `;
    document.head.appendChild(style);
  }

  function ensureModal() {
    ensureStyle();
    let modal = document.getElementById('rk-configuration-core');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'rk-configuration-core';
    modal.className = 'rk-core';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="rk-core__overlay" data-rk-core-close></div>
      <section class="rk-core__dialog" role="dialog" aria-modal="true" aria-label="${html(label('dialogAria', 'Bestellung und Beratung'))}">
        <header class="rk-core__head">
          <div><p class="rk-core__eyebrow">Ruckstuhl</p><h2>${html(label('continueTitle', 'Wie möchten Sie fortfahren?'))}</h2></div>
          <button type="button" class="rk-core__close" data-rk-core-close aria-label="${html(label('close', 'Schliessen'))}">×</button>
        </header>
        <div class="rk-core__body">
          <div data-rk-core-reference></div>
          <div data-rk-core-summary></div>
          <div class="rk-core__sharebar">
            <button type="button" class="rk-core__button rk-core__button--quiet" data-rk-core-copy-link>${html(label('copyLink', 'Konfigurationslink kopieren'))}</button>
            <button type="button" class="rk-core__button rk-core__button--quiet" data-rk-core-share>${html(label('shareLink', 'Link teilen'))}</button>
          </div>
          <div data-rk-core-country-note></div>
          <div class="rk-core__routes" data-rk-core-routes></div>
          <div class="rk-core__panel" data-rk-core-panel hidden></div>
        </div>
        <footer class="rk-core__footer">
          <span class="rk-core__status" data-rk-core-status></span>
          <button type="button" class="rk-core__button rk-core__button--quiet" data-rk-core-pdf>${html(label('pdf', 'PDF herunterladen'))}</button>
          <button type="button" class="rk-core__button" data-rk-core-submit disabled>${html(label('continue', 'Weiter'))}</button>
        </footer>
      </section>`;
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-rk-core-close]').forEach(function (button) { button.addEventListener('click', close); });
    modal.querySelector('[data-rk-core-pdf]').addEventListener('click', function () { pdf(state.normalized || state.detail); });
    modal.querySelector('[data-rk-core-copy-link]').addEventListener('click', copyShareLink);
    modal.querySelector('[data-rk-core-share]').addEventListener('click', shareConfiguration);
    modal.querySelector('[data-rk-core-submit]').addEventListener('click', submitRoute);
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) close(); });
    return modal;
  }

  function renderSummary() {
    const modal = ensureModal();
    const cfg = state.normalized;
    const rows = cfg.details.filter(function (row) {
      if (row.private) return false;
      return !['produkt','product','teppich','carpet'].includes(slug(row.label || ''));
    }).map(function (row) {
      return '<div class="rk-core__summary-row"><span>' + html(row.label) + '</span><strong>' + html(row.value) + '</strong></div>';
    }).join('');
    modal.querySelector('[data-rk-core-reference]').innerHTML = '<div class="rk-core__reference"><span>' + html(label('reference', 'Konfigurationsreferenz')) + '</span><strong>' + html(cfg.reference) + '</strong></div>';
    modal.querySelector('[data-rk-core-summary]').innerHTML = `
      <div class="rk-core__summary">
        <div class="rk-core__summary-row"><span>${html(label('product', 'Produkt'))}</span><strong>${html(cfg.product_title)}</strong></div>
        ${rows}
        <div class="rk-core__summary-row"><span>${html(label('price', 'Preis'))}</span><strong class="rk-core__price">${html(priceWithTax(cfg))}</strong></div>
      </div>`;
  }

  function renderRoutes() {
    const modal = ensureModal();
    const routes = modal.querySelector('[data-rk-core-routes]');
    const note = modal.querySelector('[data-rk-core-country-note]');
    const ch = isSwitzerland();
    const partner = settings.partnerMode && settings.partnerDealer ? settings.partnerDealer : null;
    const projectPriceOnly = !!(state.normalized && state.normalized.raw && state.normalized.raw.project_price_only);

    if (projectPriceOnly) {
      note.innerHTML = '<div class="rk-core__notice"><strong>Projektpreis</strong><br>Gerne offerieren wir Ihnen den Projektpreis ab 100 m². Bitte senden Sie die Konfiguration zur Beratung.</div>';
      if (partner) {
        routes.innerHTML = dealerAllowed(partner, 'dealer_advice')
          ? '<button type="button" class="rk-core__route" data-rk-core-route="dealer_advice"><strong>' + html(settings.labels.dealerAdvice) + '</strong><small>' + html(label('dealerDescription')) + '</small></button>'
          : '';
      } else {
        routes.innerHTML = [
          '<button type="button" class="rk-core__route" data-rk-core-route="dealer_advice"><strong>' + html(settings.labels.dealerAdvice) + '</strong><small>' + html(label('dealerDescription')) + '</small></button>',
          '<button type="button" class="rk-core__route" data-rk-core-route="ruckstuhl_advice"><strong>' + html(settings.labels.ruckstuhlAdvice) + '</strong><small>' + html(label('ruckstuhlDescription')) + '</small></button>'
        ].join('');
      }
    } else if (partner) {
      note.innerHTML = '<div class="rk-core__notice"><strong>' + html(partner.name || '') + '</strong><br>' + html(ch ? label('swissNote') : label('internationalNote')) + '</div>';
      routes.innerHTML = [
        ch && dealerAllowed(partner, 'order_request') ? '<button type="button" class="rk-core__route" data-rk-core-route="order_request"><strong>' + html(settings.labels.orderRequest) + '</strong><small>' + html(label('orderDescription')) + '</small></button>' : '',
        dealerAllowed(partner, 'dealer_advice') ? '<button type="button" class="rk-core__route" data-rk-core-route="dealer_advice"><strong>' + html(settings.labels.dealerAdvice) + '</strong><small>' + html(label('dealerDescription')) + '</small></button>' : ''
      ].join('');
    } else {
      note.innerHTML = '<div class="rk-core__notice">' + html(ch ? label('swissNote') : label('internationalNote')) + '</div>';
      routes.innerHTML = [
        ch ? '<button type="button" class="rk-core__route" data-rk-core-route="order_request"><strong>' + html(settings.labels.orderRequest) + '</strong><small>' + html(label('orderDescription')) + '</small></button>' : '',
        '<button type="button" class="rk-core__route" data-rk-core-route="dealer_advice"><strong>' + html(settings.labels.dealerAdvice) + '</strong><small>' + html(label('dealerDescription')) + '</small></button>',
        '<button type="button" class="rk-core__route" data-rk-core-route="ruckstuhl_advice"><strong>' + html(settings.labels.ruckstuhlAdvice) + '</strong><small>' + html(label('ruckstuhlDescription')) + '</small></button>'
      ].join('');
    }

    routes.querySelectorAll('[data-rk-core-route]').forEach(function (button) {
      button.addEventListener('click', function () { selectRoute(button.dataset.rkCoreRoute); });
    });
  }

  function dealerTypeTokens(value, out) {
    out = out || [];
    if (value == null || value === '') return out;
    if (Array.isArray(value)) {
      value.forEach(function (item) { dealerTypeTokens(item, out); });
      return out;
    }
    if (typeof value === 'object') {
      const preferred = ['handle','value','name','display_name','displayName','key','title'];
      let used = false;
      preferred.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(value, key) && value[key] != null && value[key] !== '') {
          dealerTypeTokens(value[key], out);
          used = true;
        }
      });
      if (!used) Object.keys(value).forEach(function (key) { dealerTypeTokens(value[key], out); });
      return out;
    }
    const raw = clean(value);
    if (!raw) return out;
    if (/^[\[{]/.test(raw)) {
      try { dealerTypeTokens(JSON.parse(raw), out); return out; } catch (error) {}
    }
    raw.split(/[;,|]+/).forEach(function (item) { if (clean(item)) out.push(clean(item)); });
    return out;
  }

  function normalizeDealerType(value) {
    const normalized = dealerTypeTokens(value).map(function (item) {
      const type = slug(item).replace(/-/g, '_');
      if (['bodenbelag','bodenbelaege','teppichboden','teppichboeden','bahnenware','dealer_bodenbelag','dealer_bodenlag','dealer_bodenbelaege','fachhandel_bodenbelag','fachhandel_bodenbelaege','bodenbelag_fachhandel'].includes(type)) return 'dealer_bodenbelag';
      if (['abgepasst','abgepasste','abgepasste_teppiche','abgepasster_teppich','konfektion','dealer_abgepasste','dealer_abgepasst','dealer_abgepasste_teppiche','teppich','teppiche','rugs','area_rugs','fachhandel_teppich','fachhandel_teppiche','fachhandel_abgepasste','fachhandel_abgepasste_teppiche'].includes(type)) return 'dealer_abgepasste';
      if (['komplett','beides','alles','all','dealer_komplett','fachhandel_komplett','vollsortiment','vollsortimenter'].includes(type)) return 'dealer_komplett';
      if (['porta','dealer_porta'].includes(type)) return 'dealer_porta';
      if (['planner','architect','architekt','planer'].includes(type)) return 'planner';
      if (['internal','intern','ruckstuhl_internal'].includes(type)) return 'internal';
      return type;
    }).filter(Boolean);
    return Array.from(new Set(normalized));
  }

  function dealerAllowedForCurrentConfiguration(dealer) {
    if (!dealer || dealer.is_ruckstuhl) return true;
    const detail = state.detail || {};
    if (detail.dealer_scope_all === true) return true;
    let scope = Array.isArray(detail.dealer_scope) ? detail.dealer_scope.slice() : [];
    if (!scope.length) {
      const execution = slug(detail.configuration && detail.configuration.execution || '');
      if (execution.includes('teppichboden')) scope = ['dealer_bodenbelag','dealer_komplett'];
      else if (execution.includes('abgepasst') || execution.includes('schnittmass')) scope = ['dealer_abgepasste','dealer_komplett'];
    }
    if (!scope.length) return true;
    const normalizedScope = scope.map(function (item) { return normalizeDealerType(item)[0] || clean(item).toLowerCase(); });
    const types = normalizeDealerType(dealer.dealer_type || dealer.type);
    if (!types.length) return false;
    return types.some(function (type) { return normalizedScope.includes(type); });
  }

  function dealerAllowed(dealer, route) {
    if (!dealer) return false;
    if (!dealerAllowedForCurrentConfiguration(dealer)) return false;
    const country = clean(dealer.country).toUpperCase();
    if (route === 'order_request') {
      if (country && country !== 'CH') return false;
      return dealer.accepts_online_orders !== false && dealer.accepts_online_orders !== 'false' && !dealer.is_ruckstuhl;
    }
    if (route === 'dealer_advice') {
      return dealer.accepts_consultation !== false && dealer.accepts_consultation !== 'false' && !dealer.is_ruckstuhl;
    }
    if (route === 'ruckstuhl_advice') {
      return dealer.accepts_consultation !== false && dealer.accepts_consultation !== 'false';
    }
    return false;
  }

  function routeDealers(route) {
    const dealers = settings.dealers.slice();
    if (route === 'ruckstuhl_advice') dealers.unshift(settings.ruckstuhlLocation);
    return dealers.filter(function (dealer) { return dealerAllowed(dealer, route); });
  }

  function normalizeDealerCountry(value) {
    const raw = clean(value).toLowerCase();
    if (['ch','schweiz','switzerland','suisse','svizzera'].includes(raw)) return 'CH';
    if (['de','deutschland','germany','allemagne','germania'].includes(raw)) return 'DE';
    return raw.length === 2 ? raw.toUpperCase() : raw.toUpperCase();
  }

  function dealerDistanceKm(point, dealer) {
    const lat = Number.parseFloat(String(dealer.lat == null ? '' : dealer.lat).replace(',', '.'));
    const lng = Number.parseFloat(String(dealer.lng == null ? '' : dealer.lng).replace(',', '.'));
    if (!point || !Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) return null;
    const R = 6371;
    const dLat = (lat - point.lat) * Math.PI / 180;
    const dLng = (lng - point.lng) * Math.PI / 180;
    const s1 = Math.sin(dLat / 2);
    const s2 = Math.sin(dLng / 2);
    const q = s1*s1 + Math.cos(point.lat*Math.PI/180) * Math.cos(lat*Math.PI/180) * s2*s2;
    return 2 * R * Math.atan2(Math.sqrt(q), Math.sqrt(1-q));
  }

  function dealerText(dealer) {
    const address = clean(dealer.address);
    const postal = clean(dealer.postal_code);
    const city = clean(dealer.city).replace(/^\d{4,6}\s+/, '');
    const country = clean(dealer.country);
    const parts = [];
    if (address) parts.push(address);
    if (postal && !address.includes(postal)) parts.push(postal);
    if (city && !address.toLowerCase().includes(city.toLowerCase())) parts.push(city);
    if (country) parts.push(country);
    return parts.filter(function (value, index, all) { return value && all.indexOf(value) === index; }).join(' · ');
  }

  function compareDealerDistance(a, b) {
    if (a.__distance != null && b.__distance != null && a.__distance !== b.__distance) return a.__distance - b.__distance;
    if (a.__distance != null && b.__distance == null) return -1;
    if (a.__distance == null && b.__distance != null) return 1;
    return number(a.priority || 50) - number(b.priority || 50) || clean(a.name).localeCompare(clean(b.name), 'de');
  }

  function uniqueDealers(list) {
    const seen = new Set();
    return list.filter(function (dealer) {
      const key = clean(dealer.id) || clean(dealer.name);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function dealerIsPriorityOne(dealer) {
    return number(dealer && dealer.priority) === 1;
  }

  function compareDealerSearchResult(a, b) {
    const ap = dealerIsPriorityOne(a) ? 0 : 1;
    const bp = dealerIsPriorityOne(b) ? 0 : 1;
    if (ap !== bp) return ap - bp;
    return compareDealerDistance(a, b);
  }

  function sortDealersForSearch(dealers, query) {
    const point = state.dealerSearchPoint;
    const country = state.dealerSearchCountry;
    const locality = slug(state.dealerSearchLocality || '');
    const postal = ((clean(query).match(/\b\d{4,6}\b/) || [])[0]) || '';
    const postalNumber = Number.parseInt(postal, 10);
    const search = slug(query || '');

    function dealerPostalGap(dealer) {
      const value = Number.parseInt(clean(dealer.postal_code), 10);
      return Number.isFinite(postalNumber) && Number.isFinite(value) ? Math.abs(value - postalNumber) : 999999;
    }

    dealers.forEach(function (dealer) {
      dealer.__distance = dealerDistanceKm(point, dealer);
      const dealerCity = slug(clean(dealer.city).replace(/^\d{4,6}\s+/, ''));
      dealer.__localFallback = !!point && dealer.__distance == null && ((locality && dealerCity === locality) || (postal && dealerPostalGap(dealer) <= 5));
    });

    if (!point) {
      let matches = country ? dealers.filter(function (dealer) { return normalizeDealerCountry(dealer.country) === country; }) : dealers.slice();
      if (!matches.length) matches = dealers.slice();
      if (search && !postal) {
        const textual = matches.filter(function (dealer) {
          const haystack = slug([dealer.name, dealer.address, dealer.postal_code, dealer.city, dealer.country, dealer.email].join(' '));
          return haystack.includes(search);
        });
        if (textual.length) matches = textual;
      }
      // Falls Google nicht antwortet, niemals eine PLZ exakt filtern oder bei 1000 beginnen.
      // Die numerisch nächstliegenden PLZ dienen nur als robuster Fallback.
      return matches.sort(function (a, b) {
        if (postal) {
          const gap = dealerPostalGap(a) - dealerPostalGap(b);
          if (gap) return gap;
        }
        const ap = Number.parseInt(clean(a.postal_code), 10);
        const bp = Number.parseInt(clean(b.postal_code), 10);
        if (!search && normalizeDealerCountry(a.country) === 'CH' && normalizeDealerCountry(b.country) === 'CH' && Number.isFinite(ap) && Number.isFinite(bp) && ap !== bp) return ap - bp;
        return number(a.priority || 50) - number(b.priority || 50) || clean(a.name).localeCompare(clean(b.name), 'de');
      });
    }

    const sameCountry = country ? dealers.filter(function (dealer) { return normalizeDealerCountry(dealer.country) === country; }) : dealers.slice();
    const base = sameCountry.length ? sameCountry : dealers.slice();
    const located = base.filter(function (dealer) { return dealer.__distance != null; }).sort(compareDealerDistance);
    const localFallbacks = base.filter(function (dealer) { return dealer.__localFallback; }).sort(function (a, b) {
      const gap = dealerPostalGap(a) - dealerPostalGap(b);
      return gap || clean(a.name).localeCompare(clean(b.name), 'de');
    });

    function mergeLocal(results) {
      return uniqueDealers(results.concat(localFallbacks)).sort(compareDealerSearchResult);
    }

    if (!located.length) return localFallbacks;

    // Automatische Umkreissuche ohne PLZ-Abdeckungslogik: 20 km; bei weniger als fünf
    // Treffern 30 km; danach 50 km. Priority 1 wird erst innerhalb des gewählten Radius
    // nach oben gezogen; alle übrigen Treffer bleiben nach Distanz sortiert. Händler ohne Koordinaten bleiben bei gleicher Ortschaft
    // oder direkt benachbarter PLZ als lokaler Fallback sichtbar.
    const within20 = mergeLocal(located.filter(function (dealer) { return dealer.__distance <= 20; }));
    if (within20.length >= 5) return within20;

    const within30 = mergeLocal(located.filter(function (dealer) { return dealer.__distance <= 30; }));
    if (within30.length >= 5) return within30;

    const within50 = mergeLocal(located.filter(function (dealer) { return dealer.__distance <= 50; }));
    if (within50.length) return within50;

    return mergeLocal([located[0]]);
  }

  function ensureDealerGoogle(callback) {
    if (window.google && window.google.maps) { callback(true); return; }
    const key = clean(settings.googleMapsApiKey);
    if (!key) { callback(false); return; }
    const eventName = 'rk:configuration:google-ready';
    let completed = false;
    function finish(ok) { if (completed) return; completed = true; callback(!!ok); }
    document.addEventListener(eventName, function () { finish(true); }, { once: true });
    let script = document.querySelector('script[data-rk-configuration-google]');
    if (!script) {
      const callbackName = '__rkConfigurationGoogleReady';
      window[callbackName] = function () { document.dispatchEvent(new Event(eventName)); };
      script = document.createElement('script');
      script.dataset.rkConfigurationGoogle = '1';
      script.async = true;
      script.defer = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&callback=' + callbackName + '&loading=async';
      script.onerror = function () { finish(false); };
      document.head.appendChild(script);
    }
    setTimeout(function () { finish(!!(window.google && window.google.maps)); }, 6500);
  }

  function geocodeDealerSearch(query) {
    const cleanedQuery = clean(query);
    if (cleanedQuery && window.RKAnalytics) window.RKAnalytics.track('dealer_search', { search_term: cleanedQuery });
    const token = ++state.dealerSearchToken;
    state.dealerSearchPoint = null;
    state.dealerSearchCountry = /^\d{4}$/.test(cleanedQuery) ? 'CH' : (/^\d{5}$/.test(cleanedQuery) ? 'DE' : '');
    state.dealerSearchLocality = '';
    state.dealerSearchQuery = cleanedQuery;
    if (!cleanedQuery) { renderDealerResults(''); return; }

    // Händlername ist eine echte Suchoption. Wenn der Begriff direkt einen zulässigen
    // Händlernamen trifft (z. B. "Wohnidee"), darf Google Geocoding den Treffer
    // nicht anschliessend durch eine zufällige Ortsinterpretation überschreiben.
    const directDealerSearch = slug(cleanedQuery);
    const directDealerMatches = routeDealers(state.route).filter(function (dealer) {
      return slug(dealer && dealer.name || '').includes(directDealerSearch);
    });
    if (directDealerSearch && directDealerMatches.length) {
      renderDealerResults(cleanedQuery);
      return;
    }

    ensureDealerGoogle(function (ready) {
      if (token !== state.dealerSearchToken || !ready || !window.google || !google.maps) { renderDealerResults(cleanedQuery); return; }
      const geocoder = new google.maps.Geocoder();
      let request = { address: cleanedQuery };
      if (/^\d{4}$/.test(cleanedQuery)) request = { address: cleanedQuery + ', Schweiz', region: 'CH', componentRestrictions: { country: 'CH' } };
      else if (/^\d{5}$/.test(cleanedQuery)) request = { address: cleanedQuery + ', Deutschland', region: 'DE', componentRestrictions: { country: 'DE' } };
      geocoder.geocode(request, function (results, status) {
        if (token !== state.dealerSearchToken) return;
        if (status === 'OK' && results && results[0] && results[0].geometry && results[0].geometry.location) {
          const location = results[0].geometry.location;
          state.dealerSearchPoint = { lat: location.lat(), lng: location.lng() };
          const components = results[0].address_components || [];
          const countryPart = components.find(function (component) { return component.types.includes('country'); });
          const localityPart = components.find(function (component) {
            return component.types.includes('locality') || component.types.includes('postal_town') || component.types.includes('administrative_area_level_3');
          });
          if (countryPart) state.dealerSearchCountry = clean(countryPart.short_name).toUpperCase();
          state.dealerSearchLocality = localityPart ? clean(localityPart.long_name || localityPart.short_name) : '';
        }
        renderDealerResults(cleanedQuery);
      });
    });
  }

  function renderDealerResults(query) {
    const modal = ensureModal();
    const container = modal.querySelector('[data-rk-core-dealer-results]');
    if (!container) return;
    let dealers = sortDealersForSearch(routeDealers(state.route), query || '');
    if (state.selectedDealer) dealers = [state.selectedDealer];
    container.innerHTML = dealers.length ? dealers.map(function (dealer, index) {
      const selected = state.selectedDealer && clean(state.selectedDealer.id) === clean(dealer.id);
      const distance = dealer.__distance != null ? '<em>' + html(Math.round(dealer.__distance) + ' km') + '</em>' : '';
      return '<button type="button" class="rk-core__dealer' + (selected ? ' is-selected' : '') + '" data-rk-core-dealer-index="' + index + '"><strong>' + html(dealer.name) + '</strong><small>' + html(dealerText(dealer)) + '</small>' + distance + '</button>';
    }).join('') : '<div class="rk-core__notice">' + html(label('noDealer')) + '</div>';
    container.querySelectorAll('[data-rk-core-dealer-index]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.selectedDealer = dealers[Number(button.dataset.rkCoreDealerIndex)] || null;
        setStatus('');
        renderDealerResults(query);
        renderSelectedDealer();
        updateSubmitState();
      });
    });
  }

  function renderSelectedDealer() {
    const modal = ensureModal();
    const box = modal.querySelector('[data-rk-core-selected-dealer]');
    if (!box) return;
    if (!state.selectedDealer) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    box.hidden = false;
    box.innerHTML = '<strong>' + html(state.selectedDealer.name) + '</strong><br>' + html(dealerText(state.selectedDealer)) + (state.selectedDealer.email ? '<br>' + html(state.selectedDealer.email) : '') + '<button type="button" class="rk-core__selected-back" data-rk-core-dealer-back>' + html(label('backToDealerResults', 'Zurück zu Suchresultaten')) + '</button>';
    const back = box.querySelector('[data-rk-core-dealer-back]');
    if (back) back.addEventListener('click', function () {
      state.selectedDealer = null;
      renderDealerResults(state.dealerSearchQuery || '');
      renderSelectedDealer();
      updateSubmitState();
      const searchField = modal.querySelector('[data-rk-core-dealer-search]');
      if (searchField) searchField.focus();
    });
  }

  function contactFieldsHtml(includeAddress) {
    return `
      <h3>${html(label('contactHeading', 'Ihre Angaben'))}</h3>
      <div class="rk-core__grid">
        <div class="rk-core__field"><label>${html(label('name', 'Name'))} *</label><input type="text" data-rk-core-contact="name" value="${html(settings.customerName || '')}" autocomplete="name"></div>
        <div class="rk-core__field"><label>${html(label('email', 'E-Mail'))} *</label><input type="email" data-rk-core-contact="email" value="${html(settings.customerEmail || '')}" autocomplete="email"></div>
        <div class="rk-core__field"><label>${html(label('phone', 'Telefon'))}</label><input type="tel" data-rk-core-contact="phone" value="${html(settings.customerPhone || '')}" autocomplete="tel"></div>
        <div class="rk-core__field"><label>${html(label('company', 'Firma / Büro'))}</label><input type="text" data-rk-core-contact="company" value="${html(settings.customerCompany || '')}" autocomplete="organization"></div>
      </div>
      ${includeAddress ? `
      <div class="rk-core__field"><label>${html(label('deliveryAddress', 'Lieferadresse'))} *</label><input type="text" data-rk-core-contact="address" value="${html(settings.customerAddress || '')}" autocomplete="street-address"></div>
      <div class="rk-core__grid">
        <div class="rk-core__field"><label>${html(label('postal', 'PLZ'))} *</label><input type="text" data-rk-core-contact="postal" value="${html(settings.customerPostal || '')}" autocomplete="postal-code"></div>
        <div class="rk-core__field"><label>${html(label('city', 'Ort'))} *</label><input type="text" data-rk-core-contact="city" value="${html(settings.customerCity || '')}" autocomplete="address-level2"></div>
      </div>` : ''}
      <div class="rk-core__field"><label>${html(label('projectNote', 'Projekt / Bemerkung'))}</label><textarea rows="4" data-rk-core-contact="message"></textarea></div>`;
  }

  function selectRoute(route) {
    state.route = route;
    setStatus('');
    const partner = settings.partnerMode && settings.partnerDealer && route !== 'ruckstuhl_advice' ? settings.partnerDealer : null;
    state.selectedDealer = partner || null;
    state.dealerSearchPoint = null;
    state.dealerSearchCountry = '';
    state.dealerSearchLocality = '';
    state.dealerSearchQuery = '';
    state.dealerSearchToken += 1;
    const modal = ensureModal();
    modal.querySelectorAll('[data-rk-core-route]').forEach(function (button) {
      button.classList.toggle('is-selected', button.dataset.rkCoreRoute === route);
    });
    const panel = modal.querySelector('[data-rk-core-panel]');
    panel.hidden = false;
    const heading = route === 'order_request' ? label('dealerOrderHeading') : (route === 'dealer_advice' ? label('dealerAdviceHeading') : label('ruckstuhlHeading'));
    const actionNote = route === 'dealer_advice'
      ? '<p class="rk-core__legal">' + html(label('shareLegal')) + '</p>'
      : (route === 'order_request'
        ? '<p class="rk-core__legal">' + html(label('orderLegal')) + '</p>'
        : '<p class="rk-core__legal">' + html(label('ruckstuhlLegal')) + '</p>');

    if (partner) {
      panel.innerHTML = `
        <h3>${html(heading)}</h3>
        <div class="rk-core__selected-dealer" data-rk-core-selected-dealer></div>
        ${route === 'dealer_advice' ? '' : contactFieldsHtml(route === 'order_request')}
        ${actionNote}`;
      renderSelectedDealer();
    } else {
      panel.innerHTML = `
        <h3>${html(heading)}</h3>
        <div class="rk-core__field"><label>${html(label('dealerSearch'))}</label><input type="search" data-rk-core-dealer-search placeholder="${html(label('dealerSearchPlaceholder'))}"></div>
        <div class="rk-core__dealer-results" data-rk-core-dealer-results></div>
        <div class="rk-core__selected-dealer" data-rk-core-selected-dealer hidden></div>
        ${route === 'dealer_advice' ? '' : contactFieldsHtml(route === 'order_request')}
        ${actionNote}`;
      const search = panel.querySelector('[data-rk-core-dealer-search]');
      let searchTimer = null;
      search.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        state.selectedDealer = null;
        renderSelectedDealer();
        state.dealerSearchPoint = null;
        state.dealerSearchCountry = /^\d{4}$/.test(clean(search.value)) ? 'CH' : (/^\d{5}$/.test(clean(search.value)) ? 'DE' : '');
        state.dealerSearchLocality = '';
        state.dealerSearchQuery = search.value;
        const rawSearch = clean(search.value);
        const isPostalSearch = /^\d{4,5}$/.test(rawSearch);
        if (isPostalSearch) {
          const resultBox = modal.querySelector('[data-rk-core-dealer-results]');
          if (resultBox) resultBox.innerHTML = '<div class="rk-core__notice">Standort wird ermittelt …</div>';
        } else {
          renderDealerResults(search.value);
        }
        searchTimer = window.setTimeout(function () { geocodeDealerSearch(search.value); }, isPostalSearch ? 220 : 500);
      });
      search.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        window.clearTimeout(searchTimer);
        state.selectedDealer = null;
        renderSelectedDealer();
        geocodeDealerSearch(search.value);
      });
      renderDealerResults('');
      if (route === 'ruckstuhl_advice') {
        state.selectedDealer = routeDealers(route).find(function (dealer) { return dealer && dealer.is_ruckstuhl; }) || routeDealers(route)[0] || null;
        renderDealerResults('');
      }
      renderSelectedDealer();
    }

    const submit = modal.querySelector('[data-rk-core-submit]');
    submit.textContent = route === 'order_request' ? label('orderRequest') : (route === 'dealer_advice' ? label('shareDealer') : label('sendRuckstuhl'));
    updateSubmitState();
  }

  function getContact() {
    const modal = ensureModal();
    const out = {};
    modal.querySelectorAll('[data-rk-core-contact]').forEach(function (field) {
      out[field.dataset.rkCoreContact] = clean(field.value);
    });
    return out;
  }

  function contactValid() {
    if (state.route === 'dealer_advice') return true;
    const contact = getContact();
    if (!contact.name || !contact.email) return false;
    if (state.route === 'order_request' && (!contact.address || !contact.postal || !contact.city)) return false;
    return true;
  }

  function updateSubmitState() {
    const modal = ensureModal();
    const submit = modal.querySelector('[data-rk-core-submit]');
    const routeReady = !!state.route;
    const dealerReady = !!state.selectedDealer;
    const contactReady = routeReady ? contactValid() : false;
    submit.disabled = state.busy || !routeReady || !dealerReady || !contactReady;
    submit.setAttribute('aria-disabled', submit.disabled ? 'true' : 'false');
    modal.querySelectorAll('[data-rk-core-contact]').forEach(function (field) {
      if (!field.dataset.rkCoreBound) {
        field.dataset.rkCoreBound = '1';
        field.addEventListener('input', updateSubmitState);
      }
    });
  }

  function setStatus(text) {
    const modal = ensureModal();
    modal.querySelector('[data-rk-core-status]').textContent = clean(text);
  }

  function setBusy(busy, text) {
    state.busy = !!busy;
    setStatus(text || '');
    ensureModal().querySelector('[data-rk-core-pdf]').disabled = state.busy;
    ensureModal().querySelector('[data-rk-core-copy-link]').disabled = state.busy;
    ensureModal().querySelector('[data-rk-core-share]').disabled = state.busy;
    updateSubmitState();
  }

  async function copyShareLink() {
    try {
      await copyText(state.shareUrl || getShareUrl(state.normalized));
      setStatus(label('copied'));
    } catch (error) {
      window.prompt(label('copyPrompt'), state.shareUrl || getShareUrl(state.normalized));
    }
  }

  async function shareConfiguration() {
    const cfg = state.normalized;
    const url = state.shareUrl || getShareUrl(cfg);
    const text = cfg.product_title + ' – ' + cfg.reference + '\n' + priceWithTax(cfg);
    if (navigator.share) {
      try {
        await navigator.share({ title: cfg.product_title + ' – Teppichkonfiguration', text: text, url: url });
        setStatus(label('shared'));
        return true;
      } catch (error) {
        if (error && error.name === 'AbortError') return false;
      }
    }
    await copyShareLink();
    return false;
  }

  function configurationBody(route, dealer, contact) {
    const cfg = state.normalized;
    const routeLabel = route === 'order_request' ? label('routeOrder') : (route === 'dealer_advice' ? label('routeDealer') : label('routeRuckstuhl'));
    const lines = [
      routeLabel,
      '',
      label('reference') + ': ' + cfg.reference,
      label('product') + ': ' + cfg.product_title,
      label('price') + ': ' + priceWithTax(cfg),
      label('country') + ': ' + (window.RuckstuhlMarket && window.RuckstuhlMarket.countryName ? window.RuckstuhlMarket.countryName() : cfg.country),
      label('copyLink') + ': ' + (state.shareUrl || getShareUrl(cfg)),
      '',
      label('configuration') + ':'
    ];
    cfg.details.filter(function (row) { return !row.private; }).forEach(function (row) {
      lines.push('- ' + row.label + ': ' + row.value);
    });
    lines.push('', label('selectedDealer') + ':');
    lines.push(label('name') + ': ' + clean(dealer && dealer.name));
    lines.push(label('id') + ': ' + clean(dealer && dealer.id));
    lines.push(label('address') + ': ' + dealerText(dealer || {}));
    lines.push(label('email') + ': ' + clean(dealer && dealer.email));
    lines.push('', label('customerData') + ':');
    lines.push(label('name') + ': ' + clean(contact.name));
    lines.push(label('email') + ': ' + clean(contact.email));
    lines.push(label('phone') + ': ' + clean(contact.phone));
    lines.push(label('company') + ': ' + clean(contact.company));
    if (route === 'order_request') {
      lines.push(label('deliveryAddress') + ': ' + clean(contact.address));
      lines.push(label('postalCity') + ': ' + [clean(contact.postal), clean(contact.city)].filter(Boolean).join(' '));
    }
    lines.push('', label('projectNote') + ':');
    lines.push(clean(contact.message) || label('noValue', '—'));
    if (route === 'order_request') {
      lines.push('', label('desiredFlow'));
    }
    return lines.join('\n');
  }

  async function submitContactForm(route) {
    const form = document.getElementById(settings.contactFormId);
    if (!form) throw new Error(label('missingForm'));
    const contact = getContact();
    const dealer = state.selectedDealer || {};
    const cfg = state.normalized;
    const values = {
      name: contact.name, email: contact.email, phone: contact.phone,
      subject: (route === 'order_request' ? label('subjectOrder') : label('subjectAdvice')) + ' ' + cfg.reference,
      body: configurationBody(route, dealer, contact), reference: cfg.reference, route: route,
      dealer: clean(dealer.name), link: state.shareUrl || getShareUrl(cfg)
    };
    Object.keys(values).forEach(function (key) {
      const field = form.querySelector('[data-rk-contact-field="' + key + '"]');
      if (field) field.value = values[key] || '';
    });
    const returnTo = form.querySelector('[data-rk-contact-field="return_to"]');
    if (returnTo) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('rk_request', 'sent');
        returnTo.value = url.pathname + url.search + url.hash;
      } catch (error) {
        const separator = window.location.search ? '&' : '?';
        returnTo.value = window.location.pathname + window.location.search + separator + 'rk_request=sent' + window.location.hash;
      }
    }

    /* Shopify contact forms are protected by hCaptcha. Because this hidden
       contact form is populated and submitted programmatically, Shopify's
       normal interaction-based CAPTCHA wiring may never run. Use the
       supported Shopify.captcha.protect API before the native submit. */
    setBusy(true, label('sending'));
    window.clearTimeout(state.__rkSendWatchdog);

    let submitted = false;
    const submitNative = function () {
      if (submitted) return;
      submitted = true;
      try {
        /* Shopify's documented protected-submit pattern uses form.submit()
           inside the captcha callback so the generated h-captcha-response is
           posted together with the Liquid contact form fields. */
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        setBusy(false, '');
        setStatus(label('genericError') + ' Bitte versuchen Sie es erneut.');
      }
    };

    try {
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form, submitNative);
      } else if (typeof form.requestSubmit === 'function') {
        /* Fallback for stores where CAPTCHA is disabled. */
        form.requestSubmit();
        submitted = true;
      } else {
        submitNative();
      }
    } catch (error) {
      setBusy(false, '');
      setStatus(label('genericError') + ' Bitte versuchen Sie es erneut.');
      return false;
    }

    /* Only a safety net. A valid contact submission navigates away to the
       return_to URL; do not fail after eight seconds while CAPTCHA is still
       preparing a protected submit. */
    state.__rkSendWatchdog = window.setTimeout(function () {
      if (!state.busy || submitted) return;
      setBusy(false, '');
      setStatus(label('genericError') + ' Bitte versuchen Sie es erneut.');
    }, 30000);
    return false;
  }

  function emailDealerConfiguration() {
    const dealer = state.selectedDealer || {};
    const dealerEmail = clean(dealer.email);
    if (!dealerEmail) return false;
    const contact = getContact();
    const subject = label('subjectAdvice') + ' ' + (state.normalized ? state.normalized.reference : '');
    const body = configurationBody('dealer_advice', dealer, contact);
    window.location.href = 'mailto:' + encodeURIComponent(dealerEmail) + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    setStatus('E-Mail an ' + dealerEmail + ' wurde vorbereitet.');
    if (window.RKAnalytics) window.RKAnalytics.track('configuration_send_dealer', { dealer_name: clean(dealer.name), product_name: state.normalized && state.normalized.product_title || '' });
    return true;
  }

  async function submitRoute() {
    if (state.busy || !state.route) return;
    const modal = ensureModal();
    modal.querySelectorAll('[data-rk-core-contact]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
    if (!state.selectedDealer) {
      setStatus('Bitte zuerst einen Fachhandelspartner oder Ruckstuhl auswählen.');
      const search = modal.querySelector('[data-rk-core-dealer-search]');
      if (search) search.focus();
      return;
    }
    if (!contactValid()) {
      modal.querySelectorAll('[data-rk-core-contact]').forEach(function (field) {
        const key = field.dataset.rkCoreContact;
        const required = key === 'name' || key === 'email' || (state.route === 'order_request' && ['address','postal','city'].includes(key));
        if (required && !clean(field.value)) field.setAttribute('aria-invalid', 'true');
      });
      setStatus('Bitte alle Pflichtfelder ausfüllen.');
      const firstInvalid = modal.querySelector('[data-rk-core-contact][aria-invalid="true"]');
      if (firstInvalid) firstInvalid.focus();
      return;
    }
    try {
      if (state.route === 'dealer_advice') {
        if (!emailDealerConfiguration()) {
          setStatus('Für diesen Fachhandelspartner ist keine E-Mail-Adresse hinterlegt. Bitte wählen Sie einen anderen Händler oder ergänzen Sie die Händlerdaten.');
        }
        return;
      }
      if (window.RKAnalytics) window.RKAnalytics.track(state.route === 'order_request' ? 'product_inquiry' : 'configuration_send_ruckstuhl', { product_name: state.normalized && state.normalized.product_title || '', route: state.route });
      await submitContactForm(state.route);
    } catch (error) {
      setBusy(false, '');
      window.alert(error && error.message ? error.message : label('genericError'));
    }
  }

  function resolvePdfLogoUrl() {
    /* Immer das schwarze Standardlogo verwenden, nie das invertierte Headerlogo. */
    const explicit = document.querySelector('[data-rk-pdf-logo-url]');
    const explicitUrl = explicit ? String(explicit.getAttribute('data-rk-pdf-logo-url') || '').trim() : '';
    if (explicitUrl) return explicitUrl;
    const configured = String(settings.pdfLogoUrl || '').trim();
    if (configured) return configured;
    const image = document.querySelector('.site-header__logo-link:not(.logo--inverted) img, .site-header__logo img:not(.logo--inverted), .header-item--logo img, header img[alt*="Ruckstuhl" i]');
    if (!image) return '';
    return String(image.currentSrc || image.src || '').trim();
  }

  function validPdfImageSource(source) {
    const value = String(source || '').trim();
    if (!value || value === '—' || /placeholder|no[_-]?image|vorschau nicht verfügbar/i.test(value)) return false;
    return /^(https?:|\/\/|data:image\/|blob:)/i.test(value);
  }

  function printHtml(configuration) {
    const cfg = normalize(configuration);
    const rows = cfg.details.filter(function (row) { return !row.private; }).map(function (row) {
      return '<tr><th>' + html(row.label) + '</th><td>' + html(row.value) + '</td></tr>';
    }).join('');

    const raw = cfg.raw && typeof cfg.raw === 'object' ? cfg.raw : {};
    const carpetSource = [cfg.carpet_image, raw.carpet_image, cfg.preview_image].map(clean).find(validPdfImageSource) || '';
    const edgingSource = [cfg.edging_image, raw.edging_image].map(clean).find(validPdfImageSource) || '';
    const sketchSource = [cfg.sketch_image, raw.sketch_image].map(clean).find(validPdfImageSource) || '';
    const sketchSvg = String(cfg.sketch_svg || raw.sketch_svg || raw.preview_svg || '').trim();

    const fallbackVisuals = (Array.isArray(cfg.preview_images) ? cfg.preview_images : []).filter(validPdfImageSource);
    const fallbackCarpet = carpetSource || fallbackVisuals.find(function(src){return src !== edgingSource && src !== sketchSource;}) || '';
    const fallbackEdging = edgingSource || '';
    const materialDirection=clean(raw.material_direction || raw.materialDirection || (raw.configuration&&raw.configuration.material_direction) || '');
    const rotateCarpet=/quer|gedreht|90/i.test(materialDirection);

    const carpet = fallbackCarpet ? '<figure class="rk-pdf-carpet"><img class="' + (rotateCarpet?'is-rotated':'') + '" src="' + html(fallbackCarpet) + '" alt="" onerror="this.parentNode.remove()"></figure>' : '';
    const edging = fallbackEdging ? '<figure class="rk-pdf-edging"><img src="' + html(fallbackEdging) + '" alt="" onerror="this.parentNode.remove()"></figure>' : '';
    let sketch = '';
    if (sketchSvg && /^<svg[\s>]/i.test(sketchSvg)) {
      sketch = '<section class="rk-pdf-sketch"><div class="rk-pdf-sketch__label">' + html(window.RKV8T ? window.RKV8T('technical_sketch','Technische Skizze') : 'Technische Skizze') + '</div><div class="rk-pdf-sketch__canvas">' + sketchSvg + '</div></section>';
    } else if (sketchSource) {
      sketch = '<section class="rk-pdf-sketch"><div class="rk-pdf-sketch__label">' + html(window.RKV8T ? window.RKV8T('technical_sketch','Technische Skizze') : 'Technische Skizze') + '</div><div class="rk-pdf-sketch__canvas"><img src="' + html(sketchSource) + '" alt="" onerror="this.closest(\'.rk-pdf-sketch\').remove()"></div></section>';
    }

    const hasLeft = !!(carpet || edging);
    const isFixedVariantPdf = String(cfg.configurator_type || raw.configuratorType || raw.configurator_type || '').toLowerCase() === 'fixed_variant';
    /* Tabellenlayout statt CSS-Grid: Chrome/Safari drucken Grid/Flex in separaten
       Print-Fenstern teilweise mit vertauschten Positionen. So bleibt das Teppichbild
       links, die Einfassung exakt darunter und die technische Skizze rechts. */
    const visuals = hasLeft || sketch
      ? '<table class="rk-pdf-visual-table' + (sketch ? ' has-sketch' : ' no-sketch') + (isFixedVariantPdf ? ' is-fixed-variant' : '') + '"><tbody><tr>' +
          (hasLeft ? '<td class="rk-pdf-visual-left"><div class="rk-pdf-left-stack">' + carpet + edging + '</div></td>' : '') +
          (sketch ? '<td class="rk-pdf-visual-right">' + sketch + '</td>' : '') +
        '</tr></tbody></table>'
      : '';

    const link = getShareUrl(cfg);
    const logoUrl = resolvePdfLogoUrl();
    const wordmark = '<div class="rk-pdf-wordmark">RUCKSTUHL<small>SWISS 1881</small></div>';
    const logo = logoUrl
      ? '<div class="rk-pdf-logo-stack"><img class="rk-pdf-logo" src="' + html(logoUrl) + '" alt="" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'block\'"><div class="rk-pdf-wordmark rk-pdf-wordmark--fallback">RUCKSTUHL<small>SWISS 1881</small></div></div>'
      : wordmark;
    const footer = 'Ruckstuhl AG, Bleienbachstrasse 9, 4900 Langenthal, Schweiz, Tel. +41 62 919 86 00, info@ruckstuhl.com, ruckstuhl.com';

    return '<!doctype html><html><head><meta charset="utf-8"><title>' + html(cfg.product_title) + ' – ' + html(cfg.reference) + '</title><style>' +
      '@page{size:A4;margin:18mm 24mm 16mm}' +
      '*{box-sizing:border-box}' +
      'html,body{background:#fff}' +
      'body{font-family:"Avenir Next",Avenir,Arial,sans-serif;color:#242f3c;margin:0;font-size:10.2pt;line-height:1.42;-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
      '.rk-pdf-layout{width:100%;border-collapse:collapse}.rk-pdf-layout>thead{display:table-header-group}.rk-pdf-layout>tfoot{display:table-footer-group}.rk-pdf-layout>thead>tr>td,.rk-pdf-layout>tbody>tr>td,.rk-pdf-layout>tfoot>tr>td{padding:0;border:0}.rk-pdf-layout>tbody>tr{break-inside:auto}' +
      '.rk-pdf-page-header{height:19mm;display:flex;align-items:flex-start;justify-content:center;text-align:center}' +
      '.rk-pdf-logo-stack{display:flex;align-items:flex-start;justify-content:center;min-height:11mm}.rk-pdf-logo{display:block;width:auto;height:auto;max-width:51mm;max-height:11mm;object-fit:contain}.rk-pdf-wordmark--fallback{display:none}' +
      '.rk-pdf-wordmark{text-align:center;font-size:13pt;font-weight:500;letter-spacing:.28em;line-height:1.05;color:#000}.rk-pdf-wordmark small{display:block;margin-top:2.5mm;font-size:6.5pt;font-weight:400;letter-spacing:.55em}' +
      '.rk-pdf-page-footer{height:11mm;display:flex;align-items:flex-end;justify-content:center;text-align:center;color:#68717b;font-size:6.8pt;line-height:1.2;white-space:nowrap}' +
      '.rk-pdf-content{padding:0 2mm}.content-header{display:flex;justify-content:space-between;align-items:flex-end;gap:20px;border-bottom:1px solid #717880;padding-bottom:4mm;margin-bottom:6mm}' +
      '.title{text-transform:uppercase;letter-spacing:.18em;font-size:17pt;line-height:1.2;color:#242f3c}' +
      '.meta{text-align:right;color:#68717b;font-size:8.5pt;white-space:nowrap}.serial{font-size:10.5pt;color:#242f3c;margin-bottom:2px}' +
      '.rk-pdf-visual-table{width:100%;table-layout:fixed;border-collapse:collapse;margin:0 0 6mm;break-inside:avoid}.rk-pdf-visual-table.no-sketch{width:52mm}.rk-pdf-visual-table td{padding:0!important;border:0!important;vertical-align:top}' +
      '.rk-pdf-visual-left{width:52mm}.rk-pdf-visual-right{padding-left:9mm!important}.rk-pdf-left-stack{display:block;width:52mm}' +
      '.rk-pdf-carpet,.rk-pdf-edging{display:block;margin:0;width:52mm;overflow:hidden;background:#fff}' +
      '.rk-pdf-carpet{height:52mm}.rk-pdf-edging{height:13mm;margin-top:4mm}' +
      '.rk-pdf-carpet img,.rk-pdf-edging img{display:block;width:100%;height:100%;object-fit:cover}.rk-pdf-carpet img.is-rotated{transform:rotate(90deg) scale(1.02)}' +
      '.rk-pdf-visual-table.is-fixed-variant.no-sketch{width:140mm;margin-left:auto;margin-right:auto}.rk-pdf-visual-table.is-fixed-variant .rk-pdf-visual-left,.rk-pdf-visual-table.is-fixed-variant .rk-pdf-left-stack,.rk-pdf-visual-table.is-fixed-variant .rk-pdf-carpet{width:140mm}.rk-pdf-visual-table.is-fixed-variant .rk-pdf-carpet{height:105mm}.rk-pdf-visual-table.is-fixed-variant .rk-pdf-carpet img{object-fit:contain}' +
      '.rk-pdf-sketch{margin:0;border:1px solid #e2e2df;background:#fbfbfa;padding:3mm;height:69mm;display:flex;flex-direction:column;overflow:hidden}' +
      '.rk-pdf-sketch__label{text-transform:uppercase;letter-spacing:.16em;font-size:6.5pt;color:#707880;margin-bottom:1.5mm}' +
      '.rk-pdf-sketch__canvas{flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#fff}' +
      '.rk-pdf-sketch__canvas svg,.rk-pdf-sketch__canvas img{display:block;width:100%!important;height:100%!important;max-width:100%;max-height:59mm;object-fit:contain;overflow:visible;background:#fff}' +
      /* Explizite Print-Stile: die Klassen leben im Shop normalerweise unter einem Elternselektor.
         Im separaten PDF-Dokument fehlt dieser Elternkontext sonst und SVG-Rects werden schwarz. */
      '.rk-pdf-sketch__canvas svg text{fill:#242f3c!important;font-family:"Avenir Next",Avenir,Arial,sans-serif!important;font-size:12px!important}' +
      '.rk-pdf-sketch__canvas svg .rk-material{fill:none!important;stroke:#9da1a5!important;stroke-width:1.3!important;stroke-dasharray:5 4!important}' +
      '.rk-pdf-sketch__canvas svg .rk-rug{fill:#e8e5df!important;stroke:#242f3c!important;stroke-width:2!important}' +
      '.rk-pdf-sketch__canvas svg .rk-rest{fill:#f7f6f3!important;stroke:#9da1a5!important;stroke-width:1.3!important;stroke-dasharray:5 4!important}' +
      '.rk-pdf-sketch__canvas svg .rk-seam{fill:none!important;stroke:#242f3c!important;stroke-width:1.5!important;stroke-dasharray:4 3!important}' +
      '.details{width:100%;border-collapse:collapse}.details tr{break-inside:avoid}.details th,.details td{padding:5px 0;border-bottom:1px solid #dedede;text-align:left;vertical-align:top}' +
      '.details th{width:34%;font-weight:400;text-transform:uppercase;letter-spacing:.12em;font-size:7.8pt;color:#737b84}.details td{font-size:9.7pt}' +
      '.price{font-size:16.5pt;color:#242f3c}' +
      '.link{margin-top:5mm;padding:2.5mm 0 0;background:#fff;border-top:1px solid #dedede;font-size:7.6pt;overflow-wrap:anywhere;break-inside:avoid}.link a{color:#242f3c;text-decoration:underline;text-underline-offset:2px}' +
      '.note{margin-top:3mm;color:#727a82;font-size:8pt;break-inside:avoid}' +
      '.rk-pdf-close{position:fixed;right:18px;top:16px;z-index:50;border:1px solid #111;background:#fff;color:#111;padding:10px 16px;font:12px Avenir,Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}@media print{.rk-pdf-close{display:none!important}}' +
      '</style></head><body><button class="rk-pdf-close" type="button" onclick="window.close()">Schliessen</button>' +
      '<table class="rk-pdf-layout">' +
      '<thead><tr><td><div class="rk-pdf-page-header">' + logo + '</div></td></tr></thead>' +
      '<tfoot><tr><td><div class="rk-pdf-page-footer">' + html(footer) + '</div></td></tr></tfoot>' +
      '<tbody><tr><td><main class="rk-pdf-content">' +
      '<header class="content-header"><div class="title">' + html(label('carpetLabel', 'Teppich') + ' ' + cfg.product_title) + '</div><div class="meta"><div class="serial">' + html(cfg.reference) + '</div><div>' + html(new Date().toLocaleDateString(currentLocale())) + '</div></div></header>' +
      visuals +
      '<table class="details"><tbody>' + rows + '<tr><th>' + html(label('price')) + '</th><td class="price">' + html(priceWithTax(cfg)) + '</td></tr></tbody></table>' +
      '<div class="link"><a href="' + html(link) + '" target="_blank" rel="noopener">' + html(label('openConfigurationShort', 'Konfiguration online öffnen')) + '</a></div>' +
      '<p class="note">' + html(label('pdfNote')) + '</p>' +
      '</main></td></tr></tbody>' +
      '</table></body></html>';
  }


  function bahnenwarePrintData(cfg) {
    const raw = cfg.raw && typeof cfg.raw === 'object' ? cfg.raw : {};
    const restRugs = [raw.rest_rugs, raw.restRugs, raw.configuration && raw.configuration.rest_rugs].find(Array.isArray) || [];
    const carpetSource = [cfg.carpet_image, raw.carpet_image, cfg.preview_image].map(clean).find(validPdfImageSource) || '';
    const edgingSource = [cfg.edging_image, raw.edging_image].map(clean).find(validPdfImageSource) || '';
    const sketchSource = [cfg.sketch_image, raw.sketch_image].map(clean).find(validPdfImageSource) || '';
    const sketchSvg = String(cfg.sketch_svg || raw.sketch_svg || raw.preview_svg || '').trim();
    const mainRows = cfg.details.filter(function(row){
      const key=slug(row && row.label || '');
      return row && !row.private && key !== 'reststucke' && key !== 'reststuecke' && !key.startsWith('zusatzteppich');
    });
    const materialDirection=clean(raw.material_direction || raw.materialDirection || (raw.configuration&&raw.configuration.material_direction) || '');
    const rotateCarpet=/quer|gedreht|90/i.test(materialDirection);
    return { raw:raw, restRugs:restRugs, carpetSource:carpetSource, edgingSource:edgingSource, sketchSource:sketchSource, sketchSvg:sketchSvg, mainRows:mainRows, rotateCarpet:rotateCarpet };
  }

  function bahnenwarePrintMarkup(cfg) {
    const data = bahnenwarePrintData(cfg);
    const logoUrl = resolvePdfLogoUrl();
    const logo = logoUrl ? '<img class="bwp-logo" src="'+html(logoUrl)+'" alt="Ruckstuhl">' : '<div class="bwp-wordmark">RUCKSTUHL<small>SWISS 1881</small></div>';
    const carpet = data.carpetSource ? '<div class="bwp-carpet"><img class="'+(data.rotateCarpet?'is-rotated':'')+'" src="'+html(data.carpetSource)+'" alt=""></div>' : '';
    const edging = data.edgingSource ? '<div class="bwp-main-edging"><img src="'+html(data.edgingSource)+'" alt=""></div>' : '';
    let sketch='';
    if(data.sketchSvg && /^<svg[\s>]/i.test(data.sketchSvg)) sketch='<div class="bwp-sketch"><div class="bwp-kicker">Technische Skizze</div>'+data.sketchSvg+'</div>';
    else if(data.sketchSource) sketch='<div class="bwp-sketch"><div class="bwp-kicker">Technische Skizze</div><img src="'+html(data.sketchSource)+'" alt=""></div>';

    const rows=data.mainRows.map(function(row){
      return '<div class="bwp-row"><span>'+html(row.label)+'</span><strong>'+html(row.value)+'</strong></div>';
    }).join('');

    const rest=data.restRugs.map(function(rug,index){
      const w=number(rug.width_m!=null?rug.width_m:rug.width), l=number(rug.length_m!=null?rug.length_m:rug.length);
      const size=(w>0&&l>0)?localizedNumber(w,2,2)+' × '+localizedNumber(l,2,2)+' m':'';
      const color=clean(rug.edging_color||rug.edgingColor||'');
      const edgingLabel=clean(rug.edging||rug.edging_label||'Ohne Einfassung');
      const image=clean(rug.edging_color_image||rug.edgingColorImage||'');
      const swatch=validPdfImageSource(image)?'<div class="bwp-rest-swatch"><img src="'+html(image)+'" alt=""></div>':'';
      const rugPrice=clean(rug.price||rug.price_text||'');
      const priceLine=rugPrice?'<div class="bwp-rest-price"><span>Preis</span><strong>'+html(rugPrice)+'</strong></div>':'';
      return '<article class="bwp-rest-card"><div class="bwp-rest-title">Zusatzteppich '+(index+1)+'</div><div class="bwp-rest-size">'+html(size)+'</div><div class="bwp-rest-finish"><div><span>Einfassung</span><strong>'+html(edgingLabel)+'</strong></div><div><span>Colorit</span><strong>'+html(color||'—')+'</strong></div>'+swatch+'</div>'+priceLine+'</article>';
    }).join('');

    const visual=(carpet||edging||sketch)?'<div class="bwp-visuals"><div class="bwp-visual-left">'+carpet+edging+'</div>'+sketch+'</div>':'';
    const restSection=rest?'<section class="bwp-section bwp-rest-section"><div class="bwp-section-title">Zusatzteppiche</div><div class="bwp-rest-grid">'+rest+'</div></section>':'';
    const link=getShareUrl(cfg);
    const note=label('pdfNote') || 'Massanfertigung nach Ihrer Konfiguration. Vor Produktionsbeginn erhalten Sie eine Skizze zur Prüfung und schriftlichen Freigabe.';
    return '<div class="bwp-sheet">'+
      '<header class="bwp-header">'+logo+'<div class="bwp-ref"><strong>'+html(cfg.reference)+'</strong><span>'+html(new Date().toLocaleDateString(currentLocale()))+'</span></div></header>'+
      '<div class="bwp-title"><span>Konfiguration</span><h1>'+html(cfg.product_title)+'</h1></div>'+
      visual+
      '<section class="bwp-section"><div class="bwp-section-title">Hauptteppich</div><div class="bwp-rows">'+rows+'</div></section>'+
      restSection+
      '<section class="bwp-total"><span>Gesamtpreis</span><strong>'+html(priceWithTax(cfg))+'</strong></section>'+
      '<section class="bwp-note">'+html(note)+'</section>'+
      '<div class="bwp-link">'+html(label('openConfigurationShort','Konfiguration online öffnen'))+': <span>'+html(link)+'</span></div>'+
      '<footer class="bwp-footer">Ruckstuhl AG · Bleienbachstrasse 9 · 4900 Langenthal · Schweiz · +41 62 919 86 00 · info@ruckstuhl.com · ruckstuhl.com</footer>'+
    '</div>';
  }

  function bahnenwarePrintDocument(cfg) {
    const sheet = bahnenwarePrintMarkup(cfg);
    const title = html(cfg.product_title + ' – ' + cfg.reference);
    return '<!doctype html><html><head><meta charset="utf-8"><title>'+title+'</title><style>'+
      '@page{size:A4 portrait;margin:18mm 24mm 16mm}'+
      '*{box-sizing:border-box}html,body{background:#fff;margin:0;padding:0}'+
      'body{font-family:"Avenir Next",Avenir,Arial,sans-serif;color:#242f3c;font-size:9.2pt;line-height:1.36;-webkit-print-color-adjust:exact;print-color-adjust:exact}'+
      '.bwp-sheet{max-width:162mm;margin:0 auto;color:#242f3c}'+
      '.bwp-header{height:19mm;position:relative;display:flex;align-items:flex-start;justify-content:center;border-bottom:0;margin-bottom:2mm}'+
      '.bwp-logo{display:block;max-width:51mm;max-height:11mm;object-fit:contain}.bwp-wordmark{text-align:center;font-size:13pt;letter-spacing:.28em;color:#000}.bwp-wordmark small{display:block;font-size:6.5pt;letter-spacing:.55em;margin-top:2.5mm}'+
      '.bwp-ref{position:absolute;right:0;top:0;text-align:right;font-size:7pt;color:#727a82}.bwp-ref strong,.bwp-ref span{display:block}.bwp-ref strong{font-size:8.6pt;color:#242f3c;margin-bottom:1mm}'+
      '.bwp-title{display:flex;align-items:flex-end;justify-content:space-between;border-bottom:1px solid #717880;padding-bottom:4mm;margin-bottom:6mm}.bwp-title span{display:none}.bwp-title h1{margin:0;text-transform:uppercase;letter-spacing:.18em;font-size:17pt;font-weight:400}.bwp-title h1:before{content:"IHR TEPPICH ";}'+
      '.bwp-visuals{display:grid;grid-template-columns:52mm 1fr;gap:9mm;margin-bottom:6mm;break-inside:avoid}.bwp-visual-left{width:52mm}.bwp-carpet{width:52mm;height:52mm;overflow:hidden;background:#f5f4f1}.bwp-carpet img,.bwp-main-edging img,.bwp-sketch img{width:100%;height:100%;display:block;object-fit:cover}.bwp-carpet img.is-rotated{transform:rotate(90deg) scale(1.02)}.bwp-main-edging{width:52mm;height:13mm;margin-top:4mm;overflow:hidden;background:#f5f4f1}'+
      '.bwp-sketch{height:69mm;border:1px solid #e2e2df;background:#fbfbfa;padding:3mm;overflow:hidden;display:flex;flex-direction:column}.bwp-kicker{text-transform:uppercase;letter-spacing:.16em;color:#707880;font-size:6.5pt;margin-bottom:1.5mm}.bwp-sketch>svg,.bwp-sketch>img{display:block;flex:1;min-height:0;width:100%!important;height:100%!important;max-height:59mm;object-fit:contain;background:#fff}.bwp-sketch svg text{fill:#242f3c!important;font-family:"Avenir Next",Avenir,Arial,sans-serif!important;font-size:12px!important}.bwp-sketch svg .rk-material{fill:none!important;stroke:#9da1a5!important;stroke-width:1.3!important;stroke-dasharray:5 4!important}.bwp-sketch svg .rk-rug{fill:#e8e5df!important;stroke:#242f3c!important;stroke-width:2!important}.bwp-sketch svg .rk-rest{fill:#f7f6f3!important;stroke:#9da1a5!important;stroke-width:1.3!important;stroke-dasharray:5 4!important}.bwp-sketch svg .rk-seam{fill:none!important;stroke:#242f3c!important;stroke-width:1.5!important;stroke-dasharray:4 3!important}'+
      '.bwp-section{border-top:1px solid #cfd1d2;padding-top:2.5mm;margin-top:2.5mm;break-inside:avoid}.bwp-section-title{text-transform:uppercase;letter-spacing:.16em;font-size:6.8pt;color:#727a82;margin-bottom:1.5mm}.bwp-rows{display:block}.bwp-row{display:grid;grid-template-columns:48mm 1fr;gap:3mm;padding:1.7mm 0;border-bottom:1px solid #dedede;min-height:7mm}.bwp-row span,.bwp-rest-finish span{text-transform:uppercase;letter-spacing:.12em;font-size:7.3pt;color:#737b84}.bwp-row strong,.bwp-rest-finish strong{font-weight:400;font-size:9.2pt}'+
      '.bwp-rest-section{margin-top:4mm;padding-top:3mm}.bwp-rest-grid{display:grid;grid-template-columns:1fr 1fr;gap:4mm}.bwp-rest-card{border:1px solid #dedfdf;padding:3mm;min-height:31mm;break-inside:avoid}.bwp-rest-title{text-transform:uppercase;letter-spacing:.14em;font-size:7.2pt;color:#5e6670;margin-bottom:1mm}.bwp-rest-size{font-size:12pt;margin-bottom:2.5mm}.bwp-rest-finish{display:grid;grid-template-columns:1fr 1fr 28mm;gap:3mm;align-items:end}.bwp-rest-finish>div{display:grid;gap:.7mm}.bwp-rest-swatch{width:28mm;aspect-ratio:2/1;border:1px solid #e1e1df;overflow:hidden;background:#f5f4f1}.bwp-rest-swatch img{width:100%;height:100%;object-fit:cover;display:block}.bwp-rest-price{display:flex;justify-content:space-between;align-items:baseline;border-top:1px solid #dedfdf;margin-top:2.5mm;padding-top:2mm}.bwp-rest-price span{text-transform:uppercase;letter-spacing:.12em;font-size:7.3pt;color:#737b84}.bwp-rest-price strong{font-weight:500;font-size:10pt}'+
      '.bwp-total{display:flex;justify-content:space-between;align-items:flex-end;border-top:1.4px solid #242f3c;margin-top:5mm;padding-top:3mm;break-inside:avoid}.bwp-total span{text-transform:uppercase;letter-spacing:.16em;font-size:7.2pt}.bwp-total strong{font-size:16.5pt;font-weight:400}.bwp-note{margin-top:3mm;color:#727a82;font-size:7.7pt;break-inside:avoid}.bwp-link{margin-top:3mm;padding-top:2.5mm;border-top:1px solid #dedede;font-size:7.2pt;color:#69717a;overflow-wrap:anywhere}.bwp-link span{color:#242f3c}.bwp-footer{margin-top:5mm;padding-top:2.5mm;border-top:1px solid #dedfdf;text-align:center;color:#727a82;font-size:6.3pt;white-space:nowrap}'+
      '.bwp-close{position:fixed;right:18px;top:16px;z-index:20;border:1px solid #111;background:#fff;padding:10px 16px;font:12px Avenir,Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}@media print{.bwp-close{display:none!important}}'+
      '</style></head><body><button class="bwp-close" type="button" onclick="window.close()">Schliessen</button>'+sheet+'</body></html>';
  }

  function printBahnenwareIsolated(cfg) {
    const markup = bahnenwarePrintDocument(cfg);
    let printWindow = null;
    try { printWindow = window.open('', 'rk_bahnenware_pdf', 'width=1050,height=820,scrollbars=yes,resizable=yes'); } catch(error) { printWindow = null; }

    function armPrint(targetWindow, cleanup) {
      if (!targetWindow || !targetWindow.document) return false;
      let printed=false;
      const run=function(){
        if(printed) return;
        printed=true;
        window.setTimeout(function(){
          try{ targetWindow.focus(); targetWindow.print(); }
          catch(error){ printed=false; }
          if(cleanup) window.setTimeout(cleanup,2500);
        },120);
      };
      const images=Array.prototype.slice.call(targetWindow.document.images||[]);
      if(!images.length){ run(); return true; }
      let pending=images.filter(function(img){return !img.complete;}).length;
      if(!pending){ run(); return true; }
      const done=function(){ pending-=1; if(pending<=0) run(); };
      images.forEach(function(img){ if(!img.complete){ img.addEventListener('load',done,{once:true}); img.addEventListener('error',done,{once:true}); } });
      window.setTimeout(run,1800);
      return true;
    }

    if(printWindow && printWindow.document){
      try{
        printWindow.document.open(); printWindow.document.write(markup); printWindow.document.close();
        armPrint(printWindow);
        return;
      }catch(error){ try{printWindow.close();}catch(closeError){} }
    }

    /* Popup blockiert: in ein isoliertes iframe drucken. Niemals die Shopseite selbst drucken. */
    const frame=document.createElement('iframe');
    frame.style.cssText='position:fixed;right:0;bottom:0;width:1px;height:1px;opacity:0;pointer-events:none;border:0';
    frame.setAttribute('aria-hidden','true'); document.body.appendChild(frame);
    const doc=frame.contentWindow&&frame.contentWindow.document;
    if(!doc){ if(frame.parentNode)frame.parentNode.removeChild(frame); throw new Error('PDF-Druckfenster konnte nicht erzeugt werden'); }
    doc.open(); doc.write(markup); doc.close();
    armPrint(frame.contentWindow,function(){ if(frame.parentNode)frame.parentNode.removeChild(frame); });
  }

  function pdf(detail) {
    const cfg = normalize(detail || state.detail || window.RKCurrentConfiguration || {});
    if (window.RKAnalytics) window.RKAnalytics.track('configurator_pdf_download', { product_name: cfg.product_title || '', configuration_reference: cfg.reference || '' });
    const rawPdfType = clean(cfg.raw && (cfg.raw.configuratorType || cfg.raw.configurator_type || ''));
    const bahnenData = bahnenwarePrintData(cfg);
    if ((String(cfg.configurator_type || '').toLowerCase() === 'bahnenware' || rawPdfType.toLowerCase() === 'bahnenware') && bahnenData.restRugs.length) {
      printBahnenwareIsolated(cfg);
      return;
    }
    const markup = printHtml(cfg);

    /*
     * Open the print view synchronously from the user's click. This avoids
     * Chrome/Safari suppressing an asynchronous print call after images load.
     */
    let printWindow = null;
    try {
      printWindow = window.open('', 'rk_configuration_pdf', 'width=1050,height=820,scrollbars=yes,resizable=yes');
    } catch (error) {
      printWindow = null;
    }

    if (printWindow && printWindow.document) {
      try {
        printWindow.document.open();
        printWindow.document.write(markup);
        printWindow.document.close();

        let printed = false;
        const runPrint = function () {
          if (printed || printWindow.closed) return;
          printed = true;
          try {
            printWindow.focus();
            printWindow.print();
          } catch (error) {
            printed = false;
          }
        };

        const images = Array.prototype.slice.call(printWindow.document.images || []);
        if (!images.length) {
          window.setTimeout(runPrint, 220);
          return;
        }

        let pending = images.length;
        const imageDone = function () {
          pending -= 1;
          if (pending <= 0) window.setTimeout(runPrint, 120);
        };
        images.forEach(function (img) {
          if (img.complete) imageDone();
          else {
            img.addEventListener('load', imageDone, { once: true });
            img.addEventListener('error', imageDone, { once: true });
          }
        });
        window.setTimeout(runPrint, 1800);
        return;
      } catch (error) {
        try { printWindow.close(); } catch (closeError) {}
      }
    }

    /* Fallback when popups are restricted. */
    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '1px';
    frame.style.height = '1px';
    frame.style.opacity = '0';
    frame.style.pointerEvents = 'none';
    frame.style.border = '0';
    frame.setAttribute('aria-hidden', 'true');
    document.body.appendChild(frame);
    const doc = frame.contentWindow && frame.contentWindow.document;
    if (!doc) {
      window.print();
      return;
    }
    doc.open();
    doc.write(markup);
    doc.close();

    let fallbackPrinted = false;
    const runFallbackPrint = function () {
      if (fallbackPrinted) return;
      fallbackPrinted = true;
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (error) {
        window.print();
      }
      window.setTimeout(function () {
        if (frame.parentNode) frame.parentNode.removeChild(frame);
      }, 2200);
    };
    window.setTimeout(runFallbackPrint, 450);
  }

  function open(detail, options) {
    state.openScrollY = window.scrollY || window.pageYOffset || 0;
    state.detail = detail || window.RKCurrentConfiguration || {};
    state.normalized = normalize(state.detail);
    if (window.RKAnalytics) window.RKAnalytics.track('configurator_complete', { product_name: state.normalized.product_title || '', configuration_reference: state.normalized.reference || '' });
    state.route = '';
    state.selectedDealer = null;
    state.busy = false;
    state.shareUrl = getShareUrl(state.normalized);
    state.openedFromLink = !!(options && options.shared);
    const modal = ensureModal();
    renderSummary();
    renderRoutes();
    modal.querySelector('[data-rk-core-panel]').hidden = true;
    modal.querySelector('[data-rk-core-panel]').innerHTML = '';
    modal.querySelector('[data-rk-core-status]').textContent = state.openedFromLink ? label('sharedOpened') : '';
    modal.querySelector('[data-rk-core-submit]').disabled = true;
    modal.hidden = false;
    document.body.classList.add('rk-core-open');
    window.RKCurrentConfiguration = state.detail;
    try { window.sessionStorage.setItem('rk_current_configuration', JSON.stringify(state.detail)); } catch (error) {}
  }

  function close() {
    const restoreY = Number(state.openScrollY || 0);
    const modal = document.getElementById('rk-configuration-core');
    if (modal) modal.hidden = true;
    document.body.classList.remove('rk-core-open');
    window.requestAnimationFrame(function(){ window.scrollTo(0, restoreY); });
  }

  function shapeKind(label) {
    const value = slug(label);
    if (value.includes('rund') || value.includes('round') || value.includes('kreis')) return 'round';
    if (value.includes('oval')) return 'oval';
    if (value.includes('quadrat') || value.includes('square')) return 'square';
    if (value.includes('laufer') || value.includes('runner')) return 'rectangle';
    return 'rectangle';
  }

  function enhanceShapeSelect(select) {
    if (!select || select.dataset.rkV8ShapeCards === '1') return;
    const configuratorModal = select.closest('.rk-at-modal, [data-rk-at-modal]');
    if (!configuratorModal) return;
    /* PORTA besitzt bereits eine eigene, funktionale Formauswahl oben im Schritt
       „Form und Masse“. Die generischen V8-Karten würden dieselbe Auswahl ein
       zweites Mal darstellen und bleiben deshalb hier vollständig deaktiviert. */
    if (configuratorModal.hasAttribute('data-rk-porta-version') || configuratorModal.querySelector('[data-rk-at-shape-selector]')) return;
    if (select.closest('.rk-at-native-dimensions')) return;
    const options = Array.from(select.options || []).filter(function (option) {
      const value = slug(option.value || option.textContent || '');
      return clean(option.value) && !value.includes('laufer') && !value.includes('runner');
    });
    if (!options.length) return;
    select.dataset.rkV8ShapeCards = '1';
    select.classList.add('rk-v8-shape-native');
    const cards = document.createElement('div');
    cards.className = 'rk-v8-shape-cards';
    cards.setAttribute('role', 'radiogroup');
    options.forEach(function (option) {
      const button = document.createElement('button');
      const kind = shapeKind(option.textContent || option.value);
      button.type = 'button';
      button.className = 'rk-v8-shape-card';
      button.dataset.value = option.value;
      button.setAttribute('role', 'radio');
      button.innerHTML = '<span class="rk-v8-shape-card__symbol rk-v8-shape-card__symbol--' + kind + '" aria-hidden="true"></span><span class="rk-v8-shape-card__label">' + html(option.textContent || option.value) + '</span>';
      button.addEventListener('click', function () {
        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncShapeCards(select, cards);
      });
      cards.appendChild(button);
    });
    select.insertAdjacentElement('afterend', cards);
    select.addEventListener('change', function () { syncShapeCards(select, cards); });
    syncShapeCards(select, cards);
  }

  function syncShapeCards(select, cards) {
    Array.from(cards.querySelectorAll('.rk-v8-shape-card')).forEach(function (button) {
      const selected = String(button.dataset.value) === String(select.value);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  }

  function enhanceConfiguratorUI(root) {
    ensureStyle();
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.rk-at-modal select[id$="-shape"], [data-rk-at-modal] select[id$="-shape"]').forEach(enhanceShapeSelect);
  }

  let enhancementTimer = null;
  function scheduleEnhancement(root) {
    window.clearTimeout(enhancementTimer);
    enhancementTimer = window.setTimeout(function () { enhanceConfiguratorUI(root || document); }, 30);
  }

  function initSubmissionReceipt() {
    let url;
    try { url = new URL(window.location.href); } catch (error) { return; }
    if (url.searchParams.get('rk_request') !== 'sent') return;
    url.searchParams.delete('rk_request');
    try { window.history.replaceState({}, document.title, url.pathname + url.search + url.hash); } catch (error) {}
    const receipt = document.createElement('div');
    receipt.setAttribute('role', 'status');
    receipt.setAttribute('aria-live', 'polite');
    receipt.textContent = label('sent');
    receipt.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:2147483646;background:#111;color:#fff;padding:15px 20px;max-width:min(620px,calc(100vw - 32px));font:13px/1.45 Avenir,"Avenir Next",Arial,sans-serif;letter-spacing:.02em;box-shadow:0 12px 34px rgba(0,0,0,.2)';
    document.body.appendChild(receipt);
    window.setTimeout(function () { if (receipt.parentNode) receipt.parentNode.removeChild(receipt); }, 6500);
  }

  function initSharedLink() {
    const shared = decodeSharedLink();
    if (shared) window.setTimeout(function () { open(shared, { shared: true }); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceConfiguratorUI(document);
      initSubmissionReceipt();
      initSharedLink();
    });
  } else {
    enhanceConfiguratorUI(document);
    initSubmissionReceipt();
    initSharedLink();
  }
  document.addEventListener('shopify:section:load', function (event) { scheduleEnhancement(event.target); });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-rk-at-trigger]')) scheduleEnhancement(document);
  });
  window.addEventListener('hashchange', initSharedLink);
  if (window.MutationObserver) {
    /* RC43 Chrome: Preis-/Summary-Updates innerhalb eines geöffneten Konfigurators
       dürfen nicht jedes Mal einen vollständigen document.querySelectorAll-Lauf auslösen. */
    new MutationObserver(function (records) {
      for (const record of records) {
        for (const node of record.addedNodes || []) {
          if (!node || node.nodeType !== 1) continue;
          const relevant = (node.matches && node.matches('.rk-at-modal,[data-rk-at-modal]')) ||
            (node.querySelector && node.querySelector('.rk-at-modal,[data-rk-at-modal]'));
          if (relevant) { scheduleEnhancement(node); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('rk:configuration:buy', function (event) {
    if (!event || !event.detail) return;
    window.setTimeout(function () { open(event.detail); }, 0);
  });

  window.addEventListener('ruckstuhl:market-change', function () {
    if (!state.detail) return;
    state.normalized = normalize(state.detail);
    try { renderSummary(); } catch (error) {}
  });

  function legacyPayloadDetail(payload) {
    const source = payload && typeof payload === 'object' ? payload : {};
    const product = source.product && typeof source.product === 'object' ? source.product : {};
    const configuration = source.configuration && typeof source.configuration === 'object' ? source.configuration : {};
    const price = source.price && typeof source.price === 'object' ? source.price : {};
    const market = window.RuckstuhlMarket && window.RuckstuhlMarket.current ? window.RuckstuhlMarket.current() : null;
    const details = [];
    const push = function (rowLabel, value) {
      const cleaned = clean(value);
      if (cleaned) details.push({ label: rowLabel, value: cleaned });
    };
    push('Ausführung', configuration.execution || configuration.mode);
    push('Form', configuration.shape);
    push('Grösse', configuration.size || configuration.dimension);
    if (!configuration.size && !configuration.dimension) {
      const diameter = number(configuration.diameter_m);
      const width = number(configuration.width_m);
      const length = number(configuration.length_m);
      if (diameter) push('Grösse', 'Ø ' + diameter.toFixed(2).replace('.', ',') + ' m');
      else if (width && length) push('Grösse', width.toFixed(2).replace('.', ',') + ' × ' + length.toFixed(2).replace('.', ',') + ' m');
    }
    push('Colorit', configuration.carpet_color || configuration.color);
    push('Einfassung', configuration.edging);
    push('Colorit Einfassung', configuration.edging_color);
    if (Array.isArray(configuration.rest_rugs)) {
      configuration.rest_rugs.forEach(function (rug, index) {
        if (!rug) return;
        const width = number(rug.width_m);
        const length = number(rug.length_m);
        push(rug.label || ('Reststückteppich ' + (index + 1)), [rug.shape, width && length ? width.toFixed(2).replace('.', ',') + ' × ' + length.toFixed(2).replace('.', ',') + ' m' : '', rug.price || rug.price_text || ''].filter(Boolean).join(' · '));
      });
    }
    push('Extras', Array.isArray(configuration.extras) ? configuration.extras.join(', ') : configuration.extras);
    push('Fachhandel', source.dealer && source.dealer.name);

    const priceText = clean(price.total_text || source.price_text || source.price || '');
    return {
      mode: 'configuration',
      source: source.source || 'legacy-configurator',
      configuratorType: source.type || source.configurator_type || 'configuration',
      product_type: source.type || source.configurator_type || 'configuration',
      product_title: clean(product.title || source.product_title || 'Ruckstuhl Teppich'),
      product_id: clean(product.id || source.product_id),
      product_handle: clean(product.handle || source.product_handle),
      product_url: clean(source.source || window.location.href.split('#')[0]),
      price: priceText,
      price_text: priceText,
      price_number: number(priceText),
      currency: market ? market.currency_code : clean(price.currency || settings.currency || 'CHF'),
      tax_included: market ? (market.tax_calculation_mode === 'fixed' && number(market.vat_rate) > 0) : true,
      country: market ? market.country_code : countryCode(),
      details: details,
      production: source.production && typeof source.production === 'object' ? source.production : {}
    };
  }

  function pdfLegacy(payload) {
    return pdf(legacyPayloadDetail(payload));
  }

  window.RKConfiguration = {
    version: '8.3.0-captcha-tax',
    settings: settings,
    normalize: normalize,
    open: open,
    close: close,
    pdf: pdf,
    pdfLegacy: pdfLegacy,
    getShareUrl: getShareUrl,
    share: shareConfiguration,
    money: money,
    enhanceConfiguratorUI: enhanceConfiguratorUI
  };
})();
